
// // // import React from "react";
// // // import { Link } from "react-router-dom";
// // // import { motion } from "framer-motion";
// // // import {
// // //   GraduationCap,
// // //   IndianRupee,
// // //   Hand,
// // //   Phone,
// // //   FileText,
// // //   Upload,
// // //   CheckCircle,
// // //   CreditCard,
// // //   PartyPopper,
// // //   BookOpenCheck,
// // //   TrendingUp,
// // // } from "lucide-react";
// // // import EducationImage from "../../assets/education.jpg";
// // // import { Helmet } from "react-helmet-async";

// // // const Education = () => {
// // //   // Enhanced professional terms for the marquee
// // //   const items = [
// // //     { icon: Hand, text: "Intake Assessment" },
// // //     { icon: Phone, text: "Counselor Routing" },
// // //     { icon: FileText, text: "Application Tracking" },
// // //     { icon: Upload, text: "Document Verification" },
// // //     { icon: CheckCircle, text: "Enrollment Status" },
// // //     { icon: CreditCard, text: "Automated Invoicing" },
// // //     { icon: PartyPopper, text: "Student Onboarding" },
// // //   ];

// // //   // Framer Motion Variants
// // //   const fadeUpVariant = {
// // //     hidden: { opacity: 0, y: 30 },
// // //     visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
// // //   };

// // //   const staggerContainer = {
// // //     hidden: { opacity: 0 },
// // //     visible: {
// // //       opacity: 1,
// // //       transition: { staggerChildren: 0.15 },
// // //     },
// // //   };

// // //   return (
// // //     <>
// // //       <Helmet>
// // //         <title>Education CRM | Lead Management System for EdTech - LMSBots</title>
// // //         <meta
// // //           name="description"
// // //           content="LMSBots Education CRM helps institutes capture student leads, automate follow-ups, and boost enrollments with AI-powered lead management."
// // //         />
// // //         <meta
// // //           name="keywords"
// // //           content="education CRM, edtech lead management system, student enrollment CRM, LMS CRM software, lead tracking for institutes"
// // //         />
// // //         <meta name="robots" content="index, follow" />
// // //         <link rel="canonical" href="https://lmsbots.com/solutions/education" />

// // //         {/* Open Graph */}
// // //         <meta property="og:title" content="Education CRM for EdTech | LMSBots" />
// // //         <meta
// // //           property="og:description"
// // //           content="Capture, nurture and convert student leads with LMSBots Education CRM."
// // //         />
// // //         <meta property="og:type" content="website" />
// // //         <meta property="og:url" content="https://lmsbots.com/solutions/education" />
// // //         <meta property="og:image" content="/education-preview.jpg" />

// // //         {/* Twitter */}
// // //         <meta name="twitter:card" content="summary_large_image" />
// // //         <meta name="twitter:title" content="Education CRM | LMSBots" />
// // //         <meta
// // //           name="twitter:description"
// // //           content="Boost enrollments with AI-powered lead management for education."
// // //         />

// // //         {/* Structured Data */}
// // //         <script type="application/ld+json">
// // //           {JSON.stringify({
// // //             "@context": "https://schema.org",
// // //             "@type": "SoftwareApplication",
// // //             name: "LMSBots Education CRM",
// // //             applicationCategory: "BusinessApplication",
// // //             operatingSystem: "Web",
// // //             description:
// // //               "Education CRM platform to manage student leads, automate communication, and increase enrollments.",
// // //             url: "https://lmsbots.com/solutions/education",
// // //           })}
// // //         </script>
// // //       </Helmet>

// // //       <main className="font-sans antialiased overflow-x-hidden bg-white">
// // //         {/* Marquee Animation Styles */}
// // //         <style>{`
// // //           @keyframes scroll-left {
// // //             0% { transform: translateX(0); }
// // //             100% { transform: translateX(-50%); }
// // //           }
// // //           @keyframes scroll-right {
// // //             0% { transform: translateX(-50%); }
// // //             100% { transform: translateX(0); }
// // //           }
// // //           .animate-scroll-left {
// // //             display: flex;
// // //             width: max-content;
// // //             animation: scroll-left 25s linear infinite;
// // //           }
// // //           .animate-scroll-right {
// // //             display: flex;
// // //             width: max-content;
// // //             animation: scroll-right 25s linear infinite;
// // //           }
// // //           .animate-scroll-left:hover, .animate-scroll-right:hover {
// // //             animation-play-state: paused;
// // //           }
// // //         `}</style>

// // //         {/* HERO SECTION */}
// // //         <section className="relative bg-gray-50 py-20 lg:pt-32 overflow-hidden">
// // //           {/* Subtle Background Blobs */}
// // //           <div className="absolute inset-0 pointer-events-none">
// // //             <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-gradient-to-br from-[#f0eaf8] to-transparent rounded-full blur-3xl opacity-60 transform -translate-x-1/3 -translate-y-1/3"></div>
// // //             <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-gradient-to-tr from-blue-50 to-transparent rounded-full blur-3xl opacity-60 transform translate-x-1/3 translate-y-1/3"></div>
// // //           </div>

// // //           <div className="relative container mx-auto px-6 lg:px-12 flex flex-col lg:flex-row items-center gap-16">
// // //             <motion.div 
// // //               initial="hidden"
// // //               animate="visible"
// // //               variants={staggerContainer}
// // //               className="lg:w-7/12"
// // //             >
// // //               <motion.div variants={fadeUpVariant} className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-full border border-gray-200 shadow-sm mb-6">
// // //                 <BookOpenCheck className="w-4 h-4 text-[#673AB7]" />
// // //                 <span className="text-xs font-bold text-slate-700 tracking-wide uppercase">
// // //                   LMSBots For Modern EdTech
// // //                 </span>
// // //               </motion.div>

// // //               <motion.h1 variants={fadeUpVariant} className="text-4xl lg:text-5xl xl:text-6xl font-extrabold bg-gradient-to-br from-slate-900 via-slate-700 to-slate-800 text-transparent bg-clip-text mb-6 leading-tight tracking-tight">
// // //                 Enroll smarter, <br className="hidden lg:block" />
// // //                 <span className="bg-gradient-to-r from-blue-800 via-purple-500 to-blue-600 bg-clip-text text-transparent pb-2 block mt-2">
// // //                   engage faster.
// // //                 </span>
// // //               </motion.h1>

// // //               <motion.p variants={fadeUpVariant} className="text-lg text-slate-600 mb-10 max-w-xl leading-relaxed">
// // //                 Turn every inquiry into a lifelong learner. Our comprehensive CRM automates outreach, tracks student engagement, and accelerates enrollment—all within a single intelligent architecture.
// // //               </motion.p>

// // //               <motion.div variants={fadeUpVariant} className="flex flex-wrap gap-4">
// // //                 <Link to="/login">
// // //                   <button className="px-8 py-3.5 bg-gradient-to-r from-blue-800 via-purple-500 to-blue-600 text-white font-semibold rounded-xl shadow-lg shadow-purple-500/25 hover:shadow-purple-500/40 transform hover:-translate-y-0.5 transition-all duration-300 flex items-center gap-2">
// // //                     Get a Platform Demo
// // //                     <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
// // //                   </button>
// // //                 </Link>
// // //               </motion.div>
// // //             </motion.div>

// // //             <motion.div 
// // //               initial={{ opacity: 0, x: 50 }}
// // //               animate={{ opacity: 1, x: 0 }}
// // //               transition={{ duration: 0.8, ease: "easeOut" }}
// // //               className="lg:w-5/12 w-full relative group"
// // //             >
// // //               <div className="absolute -inset-4 bg-gradient-to-r from-blue-800 via-purple-500 to-blue-600 rounded-3xl opacity-10 group-hover:opacity-20 blur-2xl transition-opacity duration-500"></div>
// // //               <img
// // //                 src={EducationImage}
// // //                 alt="Students learning with technology"
// // //                 className="relative rounded-2xl shadow-2xl border border-gray-100 w-full h-auto object-cover transform group-hover:-translate-y-1 transition-transform duration-500"
// // //               />
// // //             </motion.div>
// // //           </div>
// // //         </section>

// // //         {/* LEAD MANAGEMENT FEATURES SECTION */}
// // //         <section className="bg-white py-24">
// // //           <div className="container mx-auto px-6 lg:px-12">
// // //             <motion.div 
// // //               initial={{ opacity: 0, y: -20 }}
// // //               whileInView={{ opacity: 1, y: 0 }}
// // //               viewport={{ once: true }}
// // //               transition={{ duration: 0.6 }}
// // //               className="text-center max-w-3xl mx-auto mb-16"
// // //             >
// // //               <h2 className="text-3xl md:text-5xl font-extrabold bg-gradient-to-br from-slate-900 via-slate-700 to-slate-800 text-transparent bg-clip-text mb-6">
// // //                 Intelligent Pipeline <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-800 via-purple-500 to-blue-600">for Institutes</span>
// // //               </h2>
// // //               <p className="text-lg text-slate-600">
// // //                 From the first click to the classroom—manage every prospective student with precision using AI-driven automation.
// // //               </p>
// // //               <div className="w-24 h-1.5 bg-gradient-to-r from-blue-800 via-purple-500 to-blue-600 mx-auto rounded-full mt-8"></div>
// // //             </motion.div>

// // //             <div className="grid lg:grid-cols-2 gap-16 items-center">
// // //               <motion.div 
// // //                 variants={staggerContainer}
// // //                 initial="hidden"
// // //                 whileInView="visible"
// // //                 viewport={{ once: true, margin: "-50px" }}
// // //                 className="order-2 lg:order-1 space-y-6"
// // //               >
// // //                 {[
// // //                   {
// // //                     title: "Omnichannel Lead Capture",
// // //                     desc: "Automatically aggregate inquiries from web forms, social campaigns, direct chats, and calls directly into a unified dashboard.",
// // //                   },
// // //                   {
// // //                     title: "Predictive Lead Scoring",
// // //                     desc: "Prioritize high-intent applicants with real-time scoring based on behavior, course interest, and demographic profiling.",
// // //                   },
// // //                   {
// // //                     title: "Automated Nurture Sequences",
// // //                     desc: "Deploy customized email, SMS, and WhatsApp drip campaigns to keep prospects engaged throughout the admission cycle.",
// // //                   },
// // //                   {
// // //                     title: "Enrollment Analytics",
// // //                     desc: "Monitor performance from initial inquiry to final fee payment with visual pipelines and conversion rate reporting.",
// // //                   },
// // //                 ].map((feature, idx) => (
// // //                   <motion.div
// // //                     variants={fadeUpVariant}
// // //                     key={idx}
// // //                     className="group relative bg-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300"
// // //                   >
// // //                     <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-gray-100 group-hover:bg-gradient-to-b group-hover:from-blue-800 group-hover:via-purple-500 group-hover:to-blue-600 rounded-l-2xl transition-colors duration-500"></div>
// // //                     <div className="pl-4">
// // //                       <h3 className="text-xl font-bold text-slate-800 mb-2 group-hover:text-[#673AB7] transition-colors duration-300">
// // //                         {feature.title}
// // //                       </h3>
// // //                       <p className="text-slate-600 text-[15px]">{feature.desc}</p>
// // //                     </div>
// // //                   </motion.div>
// // //                 ))}
// // //               </motion.div>
              
// // //               <motion.div 
// // //                 initial={{ opacity: 0, scale: 0.95 }}
// // //                 whileInView={{ opacity: 1, scale: 1 }}
// // //                 viewport={{ once: true }}
// // //                 transition={{ duration: 0.8 }}
// // //                 className="order-1 lg:order-2 relative"
// // //               >
// // //                 <div className="absolute -inset-4 bg-gradient-to-r from-blue-800 via-purple-500 to-blue-600 rounded-3xl opacity-10 blur-2xl"></div>
// // //                 <img
// // //                   src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
// // //                   alt="Lead Management Dashboard"
// // //                   className="relative rounded-2xl shadow-xl border border-gray-200 w-full h-auto object-cover"
// // //                 />
// // //               </motion.div>
// // //             </div>
// // //           </div>
// // //         </section>

// // //         {/* AUTOMATION WORKFLOWS SECTION */}
// // //         <section className="bg-gray-50 py-24 border-y border-gray-100">
// // //           <div className="container mx-auto px-6 lg:px-12">
// // //             <motion.div 
// // //               initial={{ opacity: 0, y: -20 }}
// // //               whileInView={{ opacity: 1, y: 0 }}
// // //               viewport={{ once: true }}
// // //               transition={{ duration: 0.6 }}
// // //               className="text-center mb-16"
// // //             >
// // //               <h2 className="text-3xl md:text-5xl font-extrabold bg-gradient-to-br from-slate-900 via-slate-700 to-slate-800 text-transparent bg-clip-text mb-6">
// // //                 Automate the <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-800 via-purple-500 to-blue-600">Learner's Journey</span>
// // //               </h2>
// // //               <div className="w-24 h-1.5 bg-gradient-to-r from-blue-800 via-purple-500 to-blue-600 mx-auto rounded-full"></div>
// // //             </motion.div>

// // //             <div className="grid lg:grid-cols-2 gap-16 items-center">
// // //               <motion.div 
// // //                 variants={staggerContainer}
// // //                 initial="hidden"
// // //                 whileInView="visible"
// // //                 viewport={{ once: true }}
// // //                 className="space-y-6"
// // //               >
// // //                 <motion.div variants={fadeUpVariant} className="bg-white p-8 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
// // //                   <div className="w-14 h-14 rounded-xl bg-[#f0eaf8] flex items-center justify-center text-[#673AB7] mb-6">
// // //                     <GraduationCap className="h-7 w-7" />
// // //                   </div>
// // //                   <h3 className="text-2xl font-bold text-slate-800 mb-3">From Inquiry to Enrollment</h3>
// // //                   <p className="text-slate-600 leading-relaxed">
// // //                     Automated welcome sequences, document reminders, and counselor scheduling ensure applicants keep moving forward effortlessly.
// // //                   </p>
// // //                 </motion.div>

// // //                 <motion.div variants={fadeUpVariant} className="bg-white p-8 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
// // //                   <div className="w-14 h-14 rounded-xl bg-[#f0eaf8] flex items-center justify-center text-[#673AB7] mb-6">
// // //                     <TrendingUp className="h-7 w-7" />
// // //                   </div>
// // //                   <h3 className="text-2xl font-bold text-slate-800 mb-3">Real-time Engagement Alerts</h3>
// // //                   <p className="text-slate-600 leading-relaxed">
// // //                     Know the exact moment a lead opens your email or revisits a course page. Trigger instant follow-ups to strike while intent is high.
// // //                   </p>
// // //                 </motion.div>

// // //                 <motion.div variants={fadeUpVariant} className="bg-white p-8 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
// // //                   <div className="w-14 h-14 rounded-xl bg-[#f0eaf8] flex items-center justify-center text-[#673AB7] mb-6">
// // //                     <IndianRupee className="h-7 w-7" />
// // //                   </div>
// // //                   <h3 className="text-2xl font-bold text-slate-800 mb-3">Automated Payment Reminders</h3>
// // //                   <p className="text-slate-600 leading-relaxed">
// // //                     Minimize drop-offs with scheduled fee payment nudges, integrated installment plans, and crucial deadline alerts.
// // //                   </p>
// // //                 </motion.div>
// // //               </motion.div>

// // //               <motion.div 
// // //                 initial={{ opacity: 0, x: 30 }}
// // //                 whileInView={{ opacity: 1, x: 0 }}
// // //                 viewport={{ once: true }}
// // //                 transition={{ duration: 0.8 }}
// // //                 className="relative group"
// // //               >
// // //                 <div className="absolute -inset-4 bg-gradient-to-r from-blue-800 via-purple-500 to-blue-600 rounded-3xl opacity-10 group-hover:opacity-20 blur-xl transition-opacity duration-500"></div>
// // //                 <img
// // //                   src="https://images.unsplash.com/photo-1509062522246-3755977927d7?ixlib=rb-4.0.3&auto=format&fit=crop&w=2032&q=80"
// // //                   alt="Automated workflows"
// // //                   className="relative rounded-2xl shadow-xl w-full h-auto object-cover border border-white"
// // //                 />
// // //               </motion.div>
// // //             </div>
// // //           </div>
// // //         </section>

// // //         {/* SCROLLING CONVERSATION FLOW */}
// // //         <section className="bg-white py-24 text-center overflow-hidden">
// // //           <h2 className="text-3xl md:text-5xl font-extrabold bg-gradient-to-br from-slate-900 via-slate-700 to-slate-800 text-transparent bg-clip-text mb-6">
// // //             Turn workflows into <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-800 via-purple-500 to-blue-600">conversations</span>
// // //           </h2>
// // //           <p className="text-lg text-slate-600 max-w-2xl mx-auto mb-16">
// // //             Every interaction is an opportunity to build trust. See how our CRM framework guides prospects naturally through the admissions funnel.
// // //           </p>
          
// // //           <div className="space-y-8 px-4">
// // //             {/* LEFT TO RIGHT MARQUEE */}
// // //             <div className="relative flex overflow-hidden">
// // //               <div className="animate-scroll-right flex gap-6 w-max">
// // //                 {[...items, ...items].map((item, i) => {
// // //                   const Icon = item.icon;
// // //                   return (
// // //                     <div
// // //                       key={i}
// // //                       className="px-6 py-4 bg-white border border-gray-100 text-slate-700 rounded-xl shadow-sm hover:shadow-md hover:border-[#673AB7]/30 transition-all duration-300 whitespace-nowrap font-medium flex items-center gap-3 cursor-default"
// // //                     >
// // //                       <div className="p-2 bg-[#f0eaf8] rounded-lg text-[#673AB7]">
// // //                         <Icon size={18} />
// // //                       </div>
// // //                       {item.text}
// // //                     </div>
// // //                   );
// // //                 })}
// // //               </div>
// // //             </div>

// // //             {/* RIGHT TO LEFT MARQUEE */}
// // //             <div className="relative flex overflow-hidden">
// // //               <div className="animate-scroll-left flex gap-6 w-max">
// // //                 {[...items, ...items].map((item, i) => {
// // //                   const Icon = item.icon;
// // //                   return (
// // //                     <div
// // //                       key={i}
// // //                       className="px-6 py-4 bg-white border border-gray-100 text-slate-700 rounded-xl shadow-sm hover:shadow-md hover:border-[#673AB7]/30 transition-all duration-300 whitespace-nowrap font-medium flex items-center gap-3 cursor-default"
// // //                     >
// // //                       <div className="p-2 bg-[#f0eaf8] rounded-lg text-[#673AB7]">
// // //                         <Icon size={18} />
// // //                       </div>
// // //                       {item.text}
// // //                     </div>
// // //                   );
// // //                 })}
// // //               </div>
// // //             </div>
// // //           </div>

// // //           <motion.div 
// // //             initial={{ opacity: 0, y: 20 }}
// // //             whileInView={{ opacity: 1, y: 0 }}
// // //             viewport={{ once: true }}
// // //             className="mt-16"
// // //           >
// // //             <Link to="/login">
// // //               <button className="px-8 py-3.5  bg-[#673AB7] text-white font-semibold rounded-xl  hover:shadow-purple-500/40 transform hover:-translate-y-0.5 transition-all duration-300">
// // //               Start Your Journey
// // //               </button>
// // //             </Link>
// // //           </motion.div>
// // //         </section>

// // //         {/* LEAD SCORING & ANALYTICS SECTION */}
// // //         <section className="bg-gray-50 py-24 border-t border-gray-100">
// // //           <div className="container mx-auto px-6 lg:px-12">
// // //             <div className="grid lg:grid-cols-2 gap-16 items-center">
// // //               <motion.div 
// // //                 initial={{ opacity: 0, scale: 0.95 }}
// // //                 whileInView={{ opacity: 1, scale: 1 }}
// // //                 viewport={{ once: true }}
// // //                 transition={{ duration: 0.8 }}
// // //                 className="relative group"
// // //               >
// // //                 <div className="absolute -inset-4 bg-gradient-to-r from-blue-800 via-purple-500 to-blue-600 rounded-3xl opacity-10 group-hover:opacity-20 blur-xl transition-opacity duration-500"></div>
// // //                 <img
// // //                   src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
// // //                   alt="Lead Scoring Dashboard"
// // //                   className="relative rounded-2xl shadow-xl border border-white w-full h-auto object-cover transform group-hover:-translate-y-1 transition-transform duration-500"
// // //                 />
// // //               </motion.div>

// // //               <motion.div 
// // //                 variants={staggerContainer}
// // //                 initial="hidden"
// // //                 whileInView="visible"
// // //                 viewport={{ once: true }}
// // //               >
// // //                 <motion.h2 variants={fadeUpVariant} className="text-3xl md:text-5xl font-extrabold bg-gradient-to-br from-slate-900 via-slate-700 to-slate-800 text-transparent bg-clip-text mb-6 leading-tight">
// // //                   Identify your <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-800 via-purple-500 to-blue-600">next student</span> before they apply
// // //                 </motion.h2>
                
// // //                 <motion.p variants={fadeUpVariant} className="text-lg text-slate-600 mb-8 leading-relaxed">
// // //                   Our predictive lead scoring analyzes behavior, engagement metrics, and applicant demographics to highlight exactly who is ready to enroll—allowing your admissions team to focus resources effectively.
// // //                 </motion.p>
                
// // //                 <motion.ul variants={staggerContainer} className="space-y-5 mb-10">
// // //                   {[
// // //                     "Real-time engagement tracking (email, SMS, portal)",
// // //                     "Customized scoring algorithms for specific programs",
// // //                     "Automated routing for high-priority applicants",
// // //                   ].map((text, i) => (
// // //                     <motion.li variants={fadeUpVariant} key={i} className="flex items-start gap-4">
// // //                       <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#f0eaf8] flex items-center justify-center mt-0.5">
// // //                         <CheckCircle className="w-3.5 h-3.5 text-[#673AB7]" strokeWidth={3} />
// // //                       </div>
// // //                       <span className="text-slate-700 font-medium">{text}</span>
// // //                     </motion.li>
// // //                   ))}
// // //                 </motion.ul>
                
// // //                 <motion.button variants={fadeUpVariant} className="px-6 py-3 border-2 border-[#673AB7]/20 text-[#673AB7] font-semibold rounded-xl hover:bg-[#f0eaf8] hover:border-[#673AB7]/40 transition-all duration-300">
// // //                   Explore CRM Analytics →
// // //                 </motion.button>
// // //               </motion.div>
// // //             </div>
// // //           </div>
// // //         </section>
// // //       </main>
// // //     </>
// // //   );
// // // };

// // // export default Education;









// // import React from "react";
// // import { Link } from "react-router-dom";
// // import { motion, useReducedMotion } from "framer-motion";
// // import {
// //   GraduationCap,
// //   IndianRupee,
// //   Phone,
// //   FileText,
// //   Upload,
// //   CheckCircle2,
// //   CreditCard,
// //   BookOpenCheck,
// //   TrendingUp,
// //   ArrowRight,
// //   ChevronDown,
// //   Zap,
// //   Users,
// //   MessageCircle,
// //   BarChart3,
// //   Target,
// //   Calendar,
// //   Award,
// //   Rocket,
// //   ClipboardCheck,
// //   School,
// //   Laptop,
// //   Building2,
// //   RefreshCw,
// //   Eye,
// //   Mail,
// //   Smartphone,
// //   Settings,
// // } from "lucide-react";
// // import EducationImage from "../../assets/education.jpg";
// // // NOTE: adjust this path to wherever Seo.js lives in your project
// // import Seo, { SITE_URL } from "../../WebsiteComponents/Seo";

// // const PATH = "/solutions/education";
// // const TITLE = "Education CRM & Admission Lead Management | LMSBOTS";
// // const DESCRIPTION =
// //   "LMSBOTS Education CRM helps colleges, coaching institutes and EdTech teams capture student inquiries, route them to counsellors, automate follow-ups and fee reminders, and boost enrollments.";

// // // ---------- Static content (outside the component so it isn't rebuilt on every render) ----------
// // const HERO_POINTS = ["Inquiry capture", "Counsellor routing", "Fee reminders"];

// // const FEATURES = [
// //   {
// //     icon: Users,
// //     title: "Omnichannel Lead Capture",
// //     desc: "Automatically bring inquiries from web forms, social campaigns, direct chats, and calls into one unified dashboard.",
// //   },
// //   {
// //     icon: Target,
// //     title: "Lead Scoring",
// //     desc: "Prioritize high-intent applicants with scoring based on behavior, course interest, and demographic profile.",
// //   },
// //   {
// //     icon: MessageCircle,
// //     title: "Automated Nurture Sequences",
// //     desc: "Run customized email, SMS, and WhatsApp drip campaigns that keep prospects engaged throughout the admission cycle.",
// //   },
// //   {
// //     icon: BarChart3,
// //     title: "Enrollment Analytics",
// //     desc: "Follow performance from first inquiry to final fee payment with visual pipelines and conversion reporting.",
// //   },
// // ];

// // const AUDIENCE = [
// //   {
// //     icon: GraduationCap,
// //     title: "Colleges & universities",
// //     desc: "Manage program-wise inquiries, counsellor allocation, and application deadlines in one place.",
// //   },
// //   {
// //     icon: School,
// //     title: "Coaching & training institutes",
// //     desc: "Handle batch-wise inquiries, demo-class bookings, and fee follow-ups without spreadsheets.",
// //   },
// //   {
// //     icon: Laptop,
// //     title: "EdTech platforms",
// //     desc: "Turn sign-ups, free trials, and webinar registrants into paying learners with timely nurturing.",
// //   },
// //   {
// //     icon: Building2,
// //     title: "Study-abroad & admission consultants",
// //     desc: "Track every student's documents, applications, and counsellor conversations from inquiry to visa.",
// //   },
// // ];

// // const JOURNEY_CARDS = [
// //   {
// //     icon: GraduationCap,
// //     title: "From Inquiry to Enrollment",
// //     desc: "Automated welcome sequences, document reminders, and counsellor scheduling keep applicants moving forward.",
// //   },
// //   {
// //     icon: TrendingUp,
// //     title: "Real-time Engagement Alerts",
// //     desc: "Know when a lead opens your email or revisits a course page, then trigger a follow-up while intent is high.",
// //   },
// //   {
// //     icon: IndianRupee,
// //     title: "Automated Payment Reminders",
// //     desc: "Reduce drop-offs with scheduled fee reminders, installment-plan nudges, and deadline alerts.",
// //   },
// // ];

// // const STEPS = [
// //   {
// //     icon: Users,
// //     title: "Inquiry Captured",
// //     steps: ["Website & landing pages", "Social campaigns", "Calls & chats", "Walk-in inquiries"],
// //   },
// //   {
// //     icon: Phone,
// //     title: "Counsellor Assigned",
// //     steps: ["Program-based routing", "Instant notification", "Call scheduling", "Interaction history"],
// //   },
// //   {
// //     icon: FileText,
// //     title: "Application & Documents",
// //     steps: ["Application tracking", "Document requests", "Verification status", "Deadline reminders"],
// //   },
// //   {
// //     icon: Rocket,
// //     title: "Enrollment & Onboarding",
// //     steps: ["Fee payment links", "Installment reminders", "Enrollment confirmation", "Student onboarding"],
// //   },
// // ];

// // const SCORING_POINTS = [
// //   "Engagement tracking across email, SMS, and your portal",
// //   "Scoring rules tailored to specific programs",
// //   "Automatic routing for high-priority applicants",
// // ];

// // const SCORING_SIGNALS = [
// //   { icon: Mail, label: "Email opens & clicks" },
// //   { icon: Eye, label: "Course page visits" },
// //   { icon: BookOpenCheck, label: "Program interest" },
// //   { icon: Users, label: "Applicant profile" },
// //   { icon: Smartphone, label: "SMS & WhatsApp replies" },
// //   { icon: Zap, label: "Inquiry source" },
// // ];

// // const JOURNEY_1 = [
// //   { icon: ClipboardCheck, label: "Intake assessment" },
// //   { icon: Phone, label: "Counsellor routing" },
// //   { icon: FileText, label: "Application tracking" },
// //   { icon: Upload, label: "Document verification" },
// //   { icon: CheckCircle2, label: "Enrollment status" },
// //   { icon: CreditCard, label: "Automated invoicing" },
// //   { icon: Rocket, label: "Student onboarding" },
// // ];

// // const JOURNEY_2 = [
// //   { icon: Calendar, label: "Campus visit booking" },
// //   { icon: Award, label: "Scholarship queries" },
// //   { icon: MessageCircle, label: "Welcome sequence" },
// //   { icon: IndianRupee, label: "Fee reminders" },
// //   { icon: Target, label: "High-intent alert" },
// //   { icon: Users, label: "Referral inquiries" },
// //   { icon: RefreshCw, label: "Re-engagement campaign" },
// // ];

// // const FAQS = [
// //   {
// //     q: "What is an education CRM?",
// //     a: "An education CRM is software that helps colleges, institutes, and EdTech companies capture student inquiries, assign them to counsellors, automate follow-ups, track applications and documents, and manage fee payments until the student is enrolled.",
// //   },
// //   {
// //     q: "Where can LMSBOTS capture student inquiries from?",
// //     a: "LMSBOTS captures inquiries from website forms, landing pages, social media campaigns, chats, calls, and walk-ins, and brings them into one dashboard with the source of every lead recorded.",
// //   },
// //   {
// //     q: "Can it automate follow-ups by email, SMS, and WhatsApp?",
// //     a: "Yes. You can create nurture sequences that send welcome messages, course information, document reminders, and deadline alerts through email, SMS, and WhatsApp, triggered by what each lead does.",
// //   },
// //   {
// //     q: "How are inquiries assigned to counsellors?",
// //     a: "Inquiries can be routed automatically by program, location, language, or counsellor availability. Counsellors get notified instantly, and dashboards show response times and conversion rates for each of them.",
// //   },
// //   {
// //     q: "Can LMSBOTS send fee payment reminders?",
// //     a: "Yes. You can schedule fee reminders, installment nudges, and deadline alerts, and share payment links with students and parents so that fewer admissions drop off at the payment stage.",
// //   },
// //   {
// //     q: "Is it suitable for small institutes and coaching centres?",
// //     a: "Yes. LMSBOTS works for institutes of every size, from a single coaching centre managing batches to universities with multiple campuses and large admission teams.",
// //   },
// // ];

// // const JSON_LD = [
// //   {
// //     "@context": "https://schema.org",
// //     "@type": "SoftwareApplication",
// //     name: "LMSBOTS Education CRM",
// //     url: `${SITE_URL}${PATH}`,
// //     applicationCategory: "BusinessApplication",
// //     applicationSubCategory: "Education CRM / Admission Lead Management",
// //     operatingSystem: "Web, Android, iOS",
// //     description: DESCRIPTION,
// //     publisher: { "@id": `${SITE_URL}/#organization` },
// //     featureList: FEATURES.map((f) => f.title),
// //   },
// //   {
// //     "@context": "https://schema.org",
// //     "@type": "FAQPage",
// //     mainEntity: FAQS.map(({ q, a }) => ({
// //       "@type": "Question",
// //       name: q,
// //       acceptedAnswer: { "@type": "Answer", text: a },
// //     })),
// //   },
// //   {
// //     "@context": "https://schema.org",
// //     "@type": "BreadcrumbList",
// //     itemListElement: [
// //       { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
// //       { "@type": "ListItem", position: 2, name: "Solutions", item: `${SITE_URL}/solutions` },
// //       { "@type": "ListItem", position: 3, name: "Education", item: `${SITE_URL}${PATH}` },
// //     ],
// //   },
// // ];

// // const fadeUp = {
// //   hidden: { opacity: 0, y: 30 },
// //   visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
// // };

// // const stagger = {
// //   hidden: { opacity: 0 },
// //   visible: { opacity: 1, transition: { staggerChildren: 0.12 } },
// // };

// // // Scrolling-journey animation. Respects reduced motion: becomes a static wrapped list.
// // const MARQUEE_CSS = `
// // .edu-track{display:flex;width:max-content}
// // @keyframes edu-left{from{transform:translateX(0)}to{transform:translateX(-50%)}}
// // @keyframes edu-right{from{transform:translateX(-50%)}to{transform:translateX(0)}}
// // @media (prefers-reduced-motion: no-preference){
// //   .edu-left{animation:edu-left 45s linear infinite}
// //   .edu-right{animation:edu-right 45s linear infinite}
// //   .edu-pause:hover .edu-track,.edu-pause:focus-within .edu-track{animation-play-state:paused}
// // }
// // @media (prefers-reduced-motion: reduce){
// //   .edu-track{width:auto;flex-wrap:wrap;justify-content:center}
// //   .edu-dup{display:none}
// // }
// // `;

// // // ---------- Small shared pieces ----------
// // const Pill = ({ icon: Icon, children }) => (
// //   <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-[#48247f]/15 bg-white px-3 py-1 text-xs font-medium text-[#48247f] shadow-sm">
// //     {Icon ? <Icon className="h-3.5 w-3.5 text-[#702cb0]" /> : <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#12dfbd]" />}
// //     {children}
// //   </div>
// // );

// // const SectionHeading = ({ id, pill, icon, before, highlight, after, text, align = "center" }) => (
// //   <div className={`mb-10 max-w-3xl lg:mb-14 ${align === "center" ? "mx-auto text-center" : "text-center lg:text-left"}`}>
// //     <Pill icon={icon}>{pill}</Pill>
// //     <h2
// //       id={id}
// //       className="text-balance text-[26px] font-light leading-[1.25] tracking-tight text-[#28194f] sm:text-[34px] lg:text-[38px]"
// //     >
// //       {before}{" "}
// //       <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
// //         {highlight}
// //       </span>
// //       {after ? ` ${after}` : ""}
// //     </h2>
// //     {text && (
// //       <p className={`mt-4 max-w-[640px] text-[15px] leading-[1.75] text-[#3b2a63] sm:text-base ${align === "center" ? "mx-auto" : "mx-auto lg:mx-0"}`}>
// //         {text}
// //       </p>
// //     )}
// //     <div className={`mt-6 h-1 w-24 rounded-full bg-gradient-to-r from-[#12dfbd] via-[#702cb0] to-[#48247f] ${align === "center" ? "mx-auto" : "mx-auto lg:mx-0"}`} />
// //   </div>
// // );

// // const IconTile = ({ icon: Icon, size = "md" }) => (
// //   <div
// //     className={`inline-flex flex-shrink-0 items-center justify-center rounded-xl bg-[#f1ecfa] text-[#48247f] transition-all duration-300 group-hover:-rotate-6 group-hover:bg-gradient-to-br group-hover:from-[#48247f] group-hover:to-[#702cb0] group-hover:text-white ${
// //       size === "lg" ? "h-14 w-14" : "h-12 w-12"
// //     }`}
// //   >
// //     <Icon className={size === "lg" ? "h-7 w-7" : "h-6 w-6"} />
// //   </div>
// // );

// // const CARD =
// //   "group relative overflow-hidden rounded-2xl border border-[#48247f]/10 bg-white shadow-[0_8px_30px_-12px_rgba(72,36,127,0.25)] transition-all duration-300 hover:-translate-y-1 hover:border-[#702cb0]/40 hover:shadow-[0_24px_48px_-12px_rgba(72,36,127,0.4)] motion-reduce:transition-none motion-reduce:hover:translate-y-0";

// // const ACCENT_BAR =
// //   "absolute left-0 top-0 h-1 w-full origin-left scale-x-0 bg-gradient-to-r from-[#12dfbd] via-[#702cb0] to-[#48247f] transition-transform duration-500 ease-out group-hover:scale-x-100";

// // // Decorative concentric rings used behind the hero (hero uses rings, unlike the other solution pages)
// // const Rings = () => (
// //   <svg
// //     aria-hidden="true"
// //     viewBox="0 0 600 600"
// //     className="pointer-events-none absolute -left-40 -top-32 -z-10 h-[560px] w-[560px] text-[#702cb0] sm:-left-24"
// //     fill="none"
// //     stroke="currentColor"
// //   >
// //     {[90, 150, 210, 270].map((r, i) => (
// //       <circle key={r} cx="300" cy="300" r={r} strokeOpacity={0.16 - i * 0.03} strokeWidth="1.2" />
// //     ))}
// //     <circle cx="300" cy="210" r="5" fill="#12dfbd" stroke="none" opacity=".8" />
// //     <circle cx="510" cy="300" r="4" fill="#702cb0" stroke="none" opacity=".5" />
// //   </svg>
// // );

// // const JourneyChip = ({ icon: Icon, label, dup = false }) => (
// //   <li
// //     aria-hidden={dup ? "true" : undefined}
// //     className={`${dup ? "edu-dup " : ""}mx-2 inline-flex flex-shrink-0 items-center gap-3 whitespace-nowrap rounded-2xl border border-[#48247f]/10 bg-white px-5 py-3 text-sm font-medium text-[#28194f] shadow-sm sm:text-base`}
// //   >
// //     <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#f1ecfa] text-[#48247f]">
// //       <Icon className="h-4 w-4" />
// //     </span>
// //     {label}
// //   </li>
// // );

// // const Education = () => {
// //   const reduced = useReducedMotion();
// //   const item = reduced ? undefined : fadeUp;
// //   const group = reduced ? undefined : stagger;
// //   const initial = reduced ? false : "hidden";

// //   return (
// //     <>
// //       <Seo title={TITLE} description={DESCRIPTION} path={PATH} jsonLd={JSON_LD} />
// //       <style>{MARQUEE_CSS}</style>

// //       <main id="main-content" className="w-full overflow-x-clip bg-white font-sans text-[#28194f] antialiased">
// //         {/* ================= HERO (soft lavender fade with concentric rings) ================= */}
// //         <section
// //           id="education-hero"
// //           aria-labelledby="education-heading"
// //           className="relative isolate w-full overflow-hidden bg-gradient-to-b from-[#f6f3fc] via-white to-white"
// //         >
// //           <Rings />
// //           <div className="pointer-events-none absolute -bottom-24 right-0 -z-10 h-96 w-96 rounded-full bg-[#12dfbd]/15 blur-3xl" />

// //           <div className="relative z-10 mx-auto grid w-full max-w-[1500px] items-center gap-10 px-4 pb-14 pt-24 sm:gap-12 sm:px-10 sm:pb-16 sm:pt-28 lg:grid-cols-2 lg:gap-14 lg:px-14 lg:pb-20 lg:pt-32 xl:px-20">
// //             <motion.div
// //               initial={initial}
// //               animate="visible"
// //               variants={group}
// //               className="mx-auto max-w-xl text-center lg:mx-0 lg:text-left"
// //             >
// //               <motion.div variants={item}>
// //                 <Pill icon={BookOpenCheck}>LMSBOTS for Modern EdTech</Pill>
// //               </motion.div>

// //               <motion.h1
// //                 id="education-heading"
// //                 variants={item}
// //                 className="text-balance text-[28px] font-light leading-[1.25] tracking-tight sm:text-[34px] lg:text-[38px] xl:text-[42px]"
// //               >
// //                 Enroll smarter,{" "}
// //                 <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
// //                   engage faster
// //                 </span>
// //               </motion.h1>

// //               <motion.p
// //                 variants={item}
// //                 className="mx-auto mt-4 max-w-[540px] text-sm font-light leading-[1.75] text-[#3b2a63] sm:text-base lg:mx-0 lg:text-[17px]"
// //               >
// //                 Turn every inquiry into a lifelong learner. LMSBOTS automates outreach, tracks student
// //                 engagement, and accelerates enrollment, all from a single platform.
// //               </motion.p>

// //               <motion.div
// //                 variants={item}
// //                 className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-center lg:justify-start lg:gap-4"
// //               >
// //                 <Link
// //                   to="/contact"
// //                   className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-[#12dfbd] px-6 py-3 text-xs font-semibold text-[#102b37] shadow-lg shadow-[#12dfbd]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#40f0d3] hover:shadow-[#12dfbd]/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
// //                 >
// //                   Get a Platform Demo
// //                   <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
// //                 </Link>
// //                 <Link
// //                   to="/features"
// //                   className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-[#48247f]/20 bg-white px-6 py-3 text-xs font-medium text-[#48247f] shadow-sm transition-all duration-300 hover:border-[#702cb0]/50 hover:bg-[#f1ecfa] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
// //                 >
// //                   Explore Features
// //                 </Link>
// //               </motion.div>

// //               <motion.ul
// //                 variants={item}
// //                 className="mt-8 flex flex-wrap items-center justify-center gap-x-5 gap-y-2.5 lg:justify-start"
// //               >
// //                 {HERO_POINTS.map((p) => (
// //                   <li key={p} className="inline-flex items-center gap-2 text-xs font-medium text-[#3b2a63] sm:text-sm">
// //                     <CheckCircle2 className="h-4 w-4 text-[#0f9d86]" strokeWidth={2.5} />
// //                     {p}
// //                   </li>
// //                 ))}
// //               </motion.ul>
// //             </motion.div>

// //             <motion.div
// //               initial={reduced ? false : { opacity: 0, x: 40 }}
// //               animate={{ opacity: 1, x: 0 }}
// //               transition={{ duration: 0.8, ease: "easeOut" }}
// //               className="group relative mx-auto w-full max-w-[600px] px-3 pb-6 pt-3 lg:max-w-none"
// //             >
// //               {/* Outline frame offset behind the image (different from the filled block used on other pages) */}
// //               <div className="absolute inset-x-3 bottom-6 top-3 translate-x-3 translate-y-3 rounded-3xl border-2 border-[#702cb0]/40 bg-[#f1ecfa]/60 transition-transform duration-500 group-hover:translate-x-4 group-hover:translate-y-4 motion-reduce:transition-none" />
// //               <div className="relative rounded-2xl bg-white p-2 shadow-2xl ring-1 ring-[#48247f]/10">
// //                 <img
// //                   src={EducationImage}
// //                   alt="Students learning with technology, supported by LMSBOTS education CRM for admissions and enrollment"
// //                   width="1200"
// //                   height="800"
// //                   fetchpriority="high"
// //                   decoding="async"
// //                   className="h-auto w-full rounded-xl border border-[#48247f]/10 object-cover"
// //                 />
// //               </div>
// //             </motion.div>
// //           </div>
// //         </section>

// //         {/* ================= FEATURES ================= */}
// //         <section
// //           id="education-features"
// //           aria-labelledby="education-features-heading"
// //           className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
// //         >
// //           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
// //             <SectionHeading
// //               id="education-features-heading"
// //               pill="Key Features"
// //               icon={Settings}
// //               before="Intelligent pipeline"
// //               highlight="for institutes"
// //               text="From the first click to the classroom, manage every prospective student with precision using automation."
// //             />

// //             <motion.ul
// //               variants={group}
// //               initial={initial}
// //               whileInView="visible"
// //               viewport={{ once: true, margin: "-80px" }}
// //               className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6"
// //             >
// //               {FEATURES.map((f, i) => (
// //                 <motion.li key={f.title} variants={item} className={`${CARD} p-6`}>
// //                   <div className={ACCENT_BAR} />
// //                   <div className="mb-5 flex items-start justify-between">
// //                     <IconTile icon={f.icon} />
// //                     <span className="text-3xl font-light leading-none text-[#48247f]/15 transition-colors duration-300 group-hover:text-[#12dfbd]">
// //                       {String(i + 1).padStart(2, "0")}
// //                     </span>
// //                   </div>
// //                   <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{f.title}</h3>
// //                   <p className="text-sm leading-[1.7] text-slate-700">{f.desc}</p>
// //                 </motion.li>
// //               ))}
// //             </motion.ul>
// //           </div>
// //         </section>

// //         {/* ================= WHO IT'S FOR ================= */}
// //         <section
// //           id="education-audience"
// //           aria-labelledby="education-audience-heading"
// //           className="relative isolate w-full overflow-hidden bg-[#f6f3fc] py-14 sm:py-16 lg:py-24"
// //         >
// //           <div className="pointer-events-none absolute -right-24 -top-24 -z-10 h-96 w-96 rounded-full bg-[#702cb0]/10 blur-3xl" />
// //           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
// //             <SectionHeading
// //               id="education-audience-heading"
// //               pill="Who It's For"
// //               icon={Users}
// //               before="Built for every"
// //               highlight="admissions team"
// //               text="Whether you run one coaching centre or a multi-campus university, LMSBOTS fits the way you attract and enroll students."
// //             />

// //             <motion.ul
// //               variants={group}
// //               initial={initial}
// //               whileInView="visible"
// //               viewport={{ once: true, margin: "-80px" }}
// //               className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6"
// //             >
// //               {AUDIENCE.map((a) => (
// //                 <motion.li key={a.title} variants={item} className={`${CARD} p-6`}>
// //                   <div className={ACCENT_BAR} />
// //                   <div className="mb-4">
// //                     <IconTile icon={a.icon} />
// //                   </div>
// //                   <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{a.title}</h3>
// //                   <p className="text-sm leading-[1.7] text-slate-700">{a.desc}</p>
// //                 </motion.li>
// //               ))}
// //             </motion.ul>
// //           </div>
// //         </section>

// //         {/* ================= LEARNER'S JOURNEY AUTOMATION ================= */}
// //         <section
// //           id="education-automation"
// //           aria-labelledby="education-automation-heading"
// //           className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
// //         >
// //           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
// //             <SectionHeading
// //               id="education-automation-heading"
// //               pill="Workflow Automation"
// //               icon={RefreshCw}
// //               before="Automate the"
// //               highlight="learner's journey"
// //               text="Timely, personal outreach at every stage of the admissions funnel, without manual chasing."
// //             />

// //             <motion.ul
// //               variants={group}
// //               initial={initial}
// //               whileInView="visible"
// //               viewport={{ once: true, margin: "-80px" }}
// //               className="grid grid-cols-1 gap-5 md:grid-cols-3 lg:gap-8"
// //             >
// //               {JOURNEY_CARDS.map((c) => (
// //                 <motion.li key={c.title} variants={item} className={`${CARD} p-6 sm:p-8`}>
// //                   <div className={ACCENT_BAR} />
// //                   <div className="mb-5">
// //                     <IconTile icon={c.icon} size="lg" />
// //                   </div>
// //                   <h3 className="mb-3 text-xl font-medium tracking-tight text-[#28194f]">{c.title}</h3>
// //                   <p className="text-sm leading-[1.75] text-slate-700 sm:text-[15px]">{c.desc}</p>
// //                 </motion.li>
// //               ))}
// //             </motion.ul>
// //           </div>
// //         </section>

// //         {/* ================= ADMISSIONS WORKFLOW ================= */}
// //         <section
// //           id="education-workflow"
// //           aria-labelledby="education-workflow-heading"
// //           className="relative isolate w-full overflow-hidden border-y border-[#48247f]/10 bg-[#f6f3fc] py-14 sm:py-16 lg:py-24"
// //         >
// //           <div className="pointer-events-none absolute -bottom-24 -left-24 -z-10 h-96 w-96 rounded-full bg-[#12dfbd]/15 blur-3xl" />
// //           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
// //             <SectionHeading
// //               id="education-workflow-heading"
// //               pill="Admissions Workflow"
// //               icon={ClipboardCheck}
// //               before="From"
// //               highlight="inquiry to enrolled student"
// //               after="in 4 steps"
// //               text="A clear, automated path that keeps every applicant, and every counsellor, on track."
// //             />

// //             <motion.ol
// //               variants={group}
// //               initial={initial}
// //               whileInView="visible"
// //               viewport={{ once: true, margin: "-80px" }}
// //               className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4 lg:gap-6"
// //             >
// //               {STEPS.map((w, i) => (
// //                 <motion.li key={w.title} variants={item} className={`${CARD} h-full p-6`}>
// //                   <div className={ACCENT_BAR} />
// //                   <div className="mb-5 flex items-start justify-between">
// //                     <IconTile icon={w.icon} />
// //                     <span className="text-3xl font-light leading-none text-[#48247f]/15 transition-colors duration-300 group-hover:text-[#12dfbd]">
// //                       {String(i + 1).padStart(2, "0")}
// //                     </span>
// //                   </div>
// //                   <h3 className="mb-4 text-lg font-medium tracking-tight text-[#28194f]">{w.title}</h3>
// //                   <ul className="space-y-2.5">
// //                     {w.steps.map((s) => (
// //                       <li key={s} className="flex items-start gap-2.5 text-sm text-slate-700">
// //                         <CheckCircle2 className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#0f9d86]" strokeWidth={2.5} />
// //                         <span>{s}</span>
// //                       </li>
// //                     ))}
// //                   </ul>
// //                 </motion.li>
// //               ))}
// //             </motion.ol>
// //           </div>
// //         </section>

// //         {/* ================= CONVERSATION FLOW (MARQUEE) ================= */}
// //         <section
// //           id="education-conversations"
// //           aria-labelledby="education-conversations-heading"
// //           className="relative w-full overflow-hidden bg-white py-14 sm:py-16 lg:py-24"
// //         >
// //           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
// //             <SectionHeading
// //               id="education-conversations-heading"
// //               pill="Student Conversations"
// //               before="Turn workflows into"
// //               highlight="conversations"
// //               text="Every interaction is a chance to build trust. See how LMSBOTS guides prospects naturally through the admissions funnel."
// //             />
// //           </div>

// //           <div className="edu-pause relative space-y-4" role="group" aria-label="Examples of admissions funnel touchpoints">
// //             <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-white to-transparent sm:w-32" />
// //             <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-white to-transparent sm:w-32" />

// //             {[
// //               { list: JOURNEY_1, dir: "edu-right" },
// //               { list: JOURNEY_2, dir: "edu-left" },
// //             ].map(({ list, dir }) => (
// //               <div key={dir} className="overflow-hidden">
// //                 <ul className={`edu-track ${dir}`}>
// //                   {list.map((j) => (
// //                     <JourneyChip key={j.label} {...j} />
// //                   ))}
// //                   {/* Duplicate set makes the loop seamless; hidden from assistive tech and reduced-motion users */}
// //                   {list.map((j) => (
// //                     <JourneyChip key={`dup-${j.label}`} dup {...j} />
// //                   ))}
// //                 </ul>
// //               </div>
// //             ))}
// //           </div>

// //           <div className="mt-10 text-center">
// //             <Link
// //               to="/contact"
// //               className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-[#48247f] to-[#702cb0] px-7 py-3 text-xs font-semibold text-white shadow-lg shadow-[#48247f]/25 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[#48247f]/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
// //             >
// //               Start Your Journey
// //               <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
// //             </Link>
// //           </div>
// //         </section>

// //         {/* ================= LEAD SCORING ================= */}
// //         <section
// //           id="education-scoring"
// //           aria-labelledby="education-scoring-heading"
// //           className="relative isolate w-full overflow-hidden border-t border-[#48247f]/10 bg-[#f6f3fc] py-14 sm:py-16 lg:py-24"
// //         >
// //           <div className="pointer-events-none absolute -right-24 top-0 -z-10 h-96 w-96 rounded-full bg-[#702cb0]/10 blur-3xl" />
// //           <div className="mx-auto grid w-full max-w-[1300px] items-center gap-10 px-4 sm:px-10 lg:grid-cols-2 lg:gap-16 lg:px-14">
// //             <motion.div
// //               variants={group}
// //               initial={initial}
// //               whileInView="visible"
// //               viewport={{ once: true, margin: "-80px" }}
// //               className="text-center lg:text-left"
// //             >
// //               <motion.div variants={item}>
// //                 <Pill icon={Target}>Lead Scoring &amp; Analytics</Pill>
// //               </motion.div>
// //               <motion.h2
// //                 id="education-scoring-heading"
// //                 variants={item}
// //                 className="text-balance text-[26px] font-light leading-[1.25] tracking-tight sm:text-[34px] lg:text-[38px]"
// //               >
// //                 Identify your{" "}
// //                 <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
// //                   next student
// //                 </span>{" "}
// //                 before they apply
// //               </motion.h2>
// //               <motion.p
// //                 variants={item}
// //                 className="mt-4 text-[15px] leading-[1.75] text-[#3b2a63] sm:text-base"
// //               >
// //                 Lead scoring looks at behavior, engagement, and applicant profile to show exactly who
// //                 is ready to enroll, so your admissions team can focus its time where it counts.
// //               </motion.p>

// //               <motion.ul variants={item} className="mx-auto mt-6 max-w-md space-y-3 text-left lg:mx-0">
// //                 {SCORING_POINTS.map((t) => (
// //                   <li key={t} className="flex items-start gap-3 text-sm font-medium text-[#28194f] sm:text-[15px]">
// //                     <CheckCircle2 className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#0f9d86]" strokeWidth={2.5} />
// //                     {t}
// //                   </li>
// //                 ))}
// //               </motion.ul>

// //               <motion.div variants={item} className="mt-8">
// //                 <Link
// //                   to="/features"
// //                   className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg border border-[#48247f]/20 bg-white px-6 py-3 text-xs font-medium text-[#48247f] shadow-sm transition-all duration-300 hover:border-[#702cb0]/50 hover:bg-[#f1ecfa] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
// //                 >
// //                   Explore CRM Analytics
// //                   <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
// //                 </Link>
// //               </motion.div>
// //             </motion.div>

// //             {/* Signals panel (describes what scoring considers; no sample numbers) */}
// //             <motion.div
// //               initial={reduced ? false : { opacity: 0, y: 30 }}
// //               whileInView={{ opacity: 1, y: 0 }}
// //               viewport={{ once: true, margin: "-80px" }}
// //               transition={{ duration: 0.7, ease: "easeOut" }}
// //               className="relative overflow-hidden rounded-3xl border border-[#48247f]/10 bg-white p-6 shadow-[0_24px_60px_-20px_rgba(72,36,127,0.35)] sm:p-8"
// //             >
// //               <div className="absolute left-0 top-0 h-1 w-full bg-gradient-to-r from-[#12dfbd] via-[#702cb0] to-[#48247f]" />
// //               <div className="mb-5 flex items-center gap-3">
// //                 <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#f1ecfa] text-[#48247f]">
// //                   <TrendingUp className="h-5 w-5" />
// //                 </span>
// //                 <div>
// //                   <h3 className="text-base font-medium text-[#28194f] sm:text-lg">What the score looks at</h3>
// //                   <p className="text-xs text-slate-600">Signals combined for every applicant</p>
// //                 </div>
// //               </div>

// //               <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2">
// //                 {SCORING_SIGNALS.map(({ icon: Icon, label }) => (
// //                   <li
// //                     key={label}
// //                     className="flex items-center gap-3 rounded-xl border border-[#48247f]/10 bg-[#fbf9ff] px-4 py-3 text-sm font-medium text-[#28194f]"
// //                   >
// //                     <Icon className="h-4 w-4 flex-shrink-0 text-[#702cb0]" />
// //                     {label}
// //                   </li>
// //                 ))}
// //               </ul>

// //               <div className="mt-5 flex items-center gap-2 rounded-xl bg-[#e3faf5] px-4 py-3 text-sm font-medium text-[#0b6b5a]">
// //                 <Zap className="h-4 w-4 flex-shrink-0" />
// //                 High-priority applicants are routed to a counsellor automatically.
// //               </div>
// //             </motion.div>
// //           </div>
// //         </section>

// //         {/* ================= FAQ ================= */}
// //         <section
// //           id="education-faq"
// //           aria-labelledby="education-faq-heading"
// //           className="relative isolate w-full overflow-hidden bg-white py-14 sm:py-16 lg:py-24"
// //         >
// //           <div className="pointer-events-none absolute -bottom-24 -left-24 -z-10 h-96 w-96 rounded-full bg-[#12dfbd]/15 blur-3xl" />
// //           <div className="mx-auto w-full max-w-[900px] px-4 sm:px-10 lg:px-14">
// //             <SectionHeading
// //               id="education-faq-heading"
// //               pill="FAQ"
// //               before="Education CRM"
// //               highlight="questions answered"
// //             />

// //             <div className="space-y-4">
// //               {FAQS.map(({ q, a }, i) => (
// //                 <details
// //                   key={q}
// //                   open={i === 0}
// //                   className="group overflow-hidden rounded-2xl border border-[#48247f]/10 bg-white shadow-[0_8px_30px_-14px_rgba(72,36,127,0.25)] transition-colors open:border-[#702cb0]/40"
// //                 >
// //                   <summary className="flex min-h-[64px] cursor-pointer list-none items-center justify-between gap-4 px-5 py-4 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#702cb0] sm:px-6 [&::-webkit-details-marker]:hidden">
// //                     <h3 className="flex-1 text-[15px] font-medium leading-snug text-[#28194f] sm:text-base">{q}</h3>
// //                     <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#f1ecfa] text-[#48247f] transition-all duration-300 group-open:rotate-180 group-open:bg-[#12dfbd] group-open:text-[#102b37]">
// //                       <ChevronDown className="h-5 w-5" />
// //                     </span>
// //                   </summary>
// //                   <p className="px-5 pb-6 text-sm leading-[1.75] text-slate-700 sm:px-6 sm:text-[15px]">{a}</p>
// //                 </details>
// //               ))}
// //             </div>
// //           </div>
// //         </section>

// //         {/* ================= CLOSING CTA ================= */}
// //         <section
// //           aria-labelledby="education-cta-heading"
// //           className="w-full bg-white px-4 pb-10 sm:px-10 sm:pb-12 lg:px-14 lg:pb-16"
// //         >
// //           <div className="relative isolate mx-auto w-full max-w-[1300px] overflow-hidden rounded-[1.5rem] border border-[#48247f]/10 bg-gradient-to-br from-[#f1ecfa] via-white to-[#f6f3fc] px-5 py-12 text-center shadow-[0_20px_60px_-20px_rgba(72,36,127,0.25)] sm:rounded-[2rem] sm:px-12 sm:py-16">
// //             <div className="pointer-events-none absolute -bottom-20 -right-20 -z-10 h-72 w-72 rounded-full bg-[#12dfbd]/20 blur-3xl" />
// //             <h2
// //               id="education-cta-heading"
// //               className="mx-auto max-w-2xl text-balance text-[26px] font-light leading-[1.25] tracking-tight sm:text-[34px]"
// //             >
// //               Ready to{" "}
// //               <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
// //                 grow your enrollments?
// //               </span>
// //             </h2>
// //             <p className="mx-auto mt-4 max-w-[560px] text-[15px] leading-[1.75] text-[#3b2a63] sm:text-base">
// //               See how LMSBOTS fits your admissions process. In a live demo we'll cover inquiry
// //               capture, counsellor routing, follow-up automation, fee reminders, and reporting.
// //             </p>
// //             <div className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
// //               <Link
// //                 to="/contact"
// //                 className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-[#12dfbd] px-7 py-3 text-xs font-semibold text-[#102b37] shadow-lg shadow-[#12dfbd]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#40f0d3] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
// //               >
// //                 Get a Platform Demo
// //                 <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
// //               </Link>
// //               <Link
// //                 to="/pricing"
// //                 className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-[#48247f]/20 bg-white px-7 py-3 text-xs font-medium text-[#48247f] shadow-sm transition-all duration-300 hover:border-[#702cb0]/50 hover:bg-[#f1ecfa] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
// //               >
// //                 View Pricing
// //               </Link>
// //             </div>
// //           </div>
// //         </section>
// //       </main>
// //     </>
// //   );
// // };

// // export default Education;








// import React from "react";
// import { Link } from "react-router-dom";
// import { motion, useReducedMotion } from "framer-motion";
// import {
//   GraduationCap,
//   IndianRupee,
//   Phone,
//   FileText,
//   Upload,
//   CheckCircle2,
//   CreditCard,
//   BookOpenCheck,
//   TrendingUp,
//   ArrowRight,
//   ChevronDown,
//   Zap,
//   Users,
//   MessageCircle,
//   BarChart3,
//   Target,
//   Calendar,
//   Award,
//   Rocket,
//   ClipboardCheck,
//   School,
//   Laptop,
//   Building2,
//   RefreshCw,
//   Eye,
//   Mail,
//   Smartphone,
//   Settings,
// } from "lucide-react";
// import EducationImage from "../../assets/education.jpg";
// // NOTE: adjust this path to wherever Seo.js lives in your project
// import Seo, { SITE_URL } from "../../WebsiteComponents/Seo";
// import { ROUTES } from "../../seoData";

// const PATH = "/solutions/education";
// const TITLE = ROUTES[PATH].title;
// const DESCRIPTION = ROUTES[PATH].description;

// // ---------- Static content (outside the component so it isn't rebuilt on every render) ----------
// const HERO_POINTS = ["Inquiry capture", "Counsellor routing", "Fee reminders"];

// const FEATURES = [
//   {
//     icon: Users,
//     title: "Omnichannel Lead Capture",
//     desc: "Automatically bring inquiries from web forms, social campaigns, direct chats, and calls into one unified dashboard.",
//   },
//   {
//     icon: Target,
//     title: "Lead Scoring",
//     desc: "Prioritize high-intent applicants with scoring based on behavior, course interest, and demographic profile.",
//   },
//   {
//     icon: MessageCircle,
//     title: "Automated Nurture Sequences",
//     desc: "Run customized email, SMS, and WhatsApp drip campaigns that keep prospects engaged throughout the admission cycle.",
//   },
//   {
//     icon: BarChart3,
//     title: "Enrollment Analytics",
//     desc: "Follow performance from first inquiry to final fee payment with visual pipelines and conversion reporting.",
//   },
// ];

// const AUDIENCE = [
//   {
//     icon: GraduationCap,
//     title: "Colleges & universities",
//     desc: "Manage program-wise inquiries, counsellor allocation, and application deadlines in one place.",
//   },
//   {
//     icon: School,
//     title: "Coaching & training institutes",
//     desc: "Handle batch-wise inquiries, demo-class bookings, and fee follow-ups without spreadsheets.",
//   },
//   {
//     icon: Laptop,
//     title: "EdTech platforms",
//     desc: "Turn sign-ups, free trials, and webinar registrants into paying learners with timely nurturing.",
//   },
//   {
//     icon: Building2,
//     title: "Study-abroad & admission consultants",
//     desc: "Track every student's documents, applications, and counsellor conversations from inquiry to visa.",
//   },
// ];

// const JOURNEY_CARDS = [
//   {
//     icon: GraduationCap,
//     title: "From Inquiry to Enrollment",
//     desc: "Automated welcome sequences, document reminders, and counsellor scheduling keep applicants moving forward.",
//   },
//   {
//     icon: TrendingUp,
//     title: "Real-time Engagement Alerts",
//     desc: "Know when a lead opens your email or revisits a course page, then trigger a follow-up while intent is high.",
//   },
//   {
//     icon: IndianRupee,
//     title: "Automated Payment Reminders",
//     desc: "Reduce drop-offs with scheduled fee reminders, installment-plan nudges, and deadline alerts.",
//   },
// ];

// const STEPS = [
//   {
//     icon: Users,
//     title: "Inquiry Captured",
//     steps: ["Website & landing pages", "Social campaigns", "Calls & chats", "Walk-in inquiries"],
//   },
//   {
//     icon: Phone,
//     title: "Counsellor Assigned",
//     steps: ["Program-based routing", "Instant notification", "Call scheduling", "Interaction history"],
//   },
//   {
//     icon: FileText,
//     title: "Application & Documents",
//     steps: ["Application tracking", "Document requests", "Verification status", "Deadline reminders"],
//   },
//   {
//     icon: Rocket,
//     title: "Enrollment & Onboarding",
//     steps: ["Fee payment links", "Installment reminders", "Enrollment confirmation", "Student onboarding"],
//   },
// ];

// const SCORING_POINTS = [
//   "Engagement tracking across email, SMS, and your portal",
//   "Scoring rules tailored to specific programs",
//   "Automatic routing for high-priority applicants",
// ];

// const SCORING_SIGNALS = [
//   { icon: Mail, label: "Email opens & clicks" },
//   { icon: Eye, label: "Course page visits" },
//   { icon: BookOpenCheck, label: "Program interest" },
//   { icon: Users, label: "Applicant profile" },
//   { icon: Smartphone, label: "SMS & WhatsApp replies" },
//   { icon: Zap, label: "Inquiry source" },
// ];

// const JOURNEY_1 = [
//   { icon: ClipboardCheck, label: "Intake assessment" },
//   { icon: Phone, label: "Counsellor routing" },
//   { icon: FileText, label: "Application tracking" },
//   { icon: Upload, label: "Document verification" },
//   { icon: CheckCircle2, label: "Enrollment status" },
//   { icon: CreditCard, label: "Automated invoicing" },
//   { icon: Rocket, label: "Student onboarding" },
// ];

// const JOURNEY_2 = [
//   { icon: Calendar, label: "Campus visit booking" },
//   { icon: Award, label: "Scholarship queries" },
//   { icon: MessageCircle, label: "Welcome sequence" },
//   { icon: IndianRupee, label: "Fee reminders" },
//   { icon: Target, label: "High-intent alert" },
//   { icon: Users, label: "Referral inquiries" },
//   { icon: RefreshCw, label: "Re-engagement campaign" },
// ];

// const FAQS = [
//   {
//     q: "What is an education CRM?",
//     a: "An education CRM is software that helps colleges, institutes, and EdTech companies capture student inquiries, assign them to counsellors, automate follow-ups, track applications and documents, and manage fee payments until the student is enrolled.",
//   },
//   {
//     q: "Where can LMSBOTS capture student inquiries from?",
//     a: "LMSBOTS captures inquiries from website forms, landing pages, social media campaigns, chats, calls, and walk-ins, and brings them into one dashboard with the source of every lead recorded.",
//   },
//   {
//     q: "Can it automate follow-ups by email, SMS, and WhatsApp?",
//     a: "Yes. You can create nurture sequences that send welcome messages, course information, document reminders, and deadline alerts through email, SMS, and WhatsApp, triggered by what each lead does.",
//   },
//   {
//     q: "How are inquiries assigned to counsellors?",
//     a: "Inquiries can be routed automatically by program, location, language, or counsellor availability. Counsellors get notified instantly, and dashboards show response times and conversion rates for each of them.",
//   },
//   {
//     q: "Can LMSBOTS send fee payment reminders?",
//     a: "Yes. You can schedule fee reminders, installment nudges, and deadline alerts, and share payment links with students and parents so that fewer admissions drop off at the payment stage.",
//   },
//   {
//     q: "Is it suitable for small institutes and coaching centres?",
//     a: "Yes. LMSBOTS works for institutes of every size, from a single coaching centre managing batches to universities with multiple campuses and large admission teams.",
//   },
// ];

// const JSON_LD = [
//   {
//     "@context": "https://schema.org",
//     "@type": "SoftwareApplication",
//     name: "LMSBOTS Education CRM",
//     url: `${SITE_URL}${PATH}`,
//     applicationCategory: "BusinessApplication",
//     applicationSubCategory: "Education CRM / Admission Lead Management",
//     operatingSystem: "Web, Android, iOS",
//     description: DESCRIPTION,
//     publisher: { "@id": `${SITE_URL}/#organization` },
//     featureList: FEATURES.map((f) => f.title),
//   },
//   {
//     "@context": "https://schema.org",
//     "@type": "FAQPage",
//     mainEntity: FAQS.map(({ q, a }) => ({
//       "@type": "Question",
//       name: q,
//       acceptedAnswer: { "@type": "Answer", text: a },
//     })),
//   },
//   {
//     "@context": "https://schema.org",
//     "@type": "BreadcrumbList",
//     itemListElement: [
//       { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
//       { "@type": "ListItem", position: 2, name: "Solutions", item: `${SITE_URL}/solutions` },
//       { "@type": "ListItem", position: 3, name: "Education", item: `${SITE_URL}${PATH}` },
//     ],
//   },
// ];

// const fadeUp = {
//   hidden: { opacity: 0, y: 30 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
// };

// const stagger = {
//   hidden: { opacity: 0 },
//   visible: { opacity: 1, transition: { staggerChildren: 0.12 } },
// };

// // Scrolling-journey animation. Respects reduced motion: becomes a static wrapped list.
// const MARQUEE_CSS = `
// .edu-track{display:flex;width:max-content}
// @keyframes edu-left{from{transform:translateX(0)}to{transform:translateX(-50%)}}
// @keyframes edu-right{from{transform:translateX(-50%)}to{transform:translateX(0)}}
// @media (prefers-reduced-motion: no-preference){
//   .edu-left{animation:edu-left 45s linear infinite}
//   .edu-right{animation:edu-right 45s linear infinite}
//   .edu-pause:hover .edu-track,.edu-pause:focus-within .edu-track{animation-play-state:paused}
// }
// @media (prefers-reduced-motion: reduce){
//   .edu-track{width:auto;flex-wrap:wrap;justify-content:center}
//   .edu-dup{display:none}
// }
// `;

// // ---------- Small shared pieces ----------
// const Pill = ({ icon: Icon, children }) => (
//   <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-[#48247f]/15 bg-white px-3 py-1 text-xs font-medium text-[#48247f] shadow-sm">
//     {Icon ? <Icon className="h-3.5 w-3.5 text-[#702cb0]" /> : <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#12dfbd]" />}
//     {children}
//   </div>
// );

// const SectionHeading = ({ id, pill, icon, before, highlight, after, text, align = "center" }) => (
//   <div className={`mb-10 max-w-3xl lg:mb-14 ${align === "center" ? "mx-auto text-center" : "text-center lg:text-left"}`}>
//     <Pill icon={icon}>{pill}</Pill>
//     <h2
//       id={id}
//       className="text-balance text-[26px] font-light leading-[1.25] tracking-tight text-[#28194f] sm:text-[34px] lg:text-[38px]"
//     >
//       {before}{" "}
//       <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
//         {highlight}
//       </span>
//       {after ? ` ${after}` : ""}
//     </h2>
//     {text && (
//       <p className={`mt-4 max-w-[640px] text-[15px] leading-[1.75] text-[#3b2a63] sm:text-base ${align === "center" ? "mx-auto" : "mx-auto lg:mx-0"}`}>
//         {text}
//       </p>
//     )}
//     <div className={`mt-6 h-1 w-24 rounded-full bg-gradient-to-r from-[#12dfbd] via-[#702cb0] to-[#48247f] ${align === "center" ? "mx-auto" : "mx-auto lg:mx-0"}`} />
//   </div>
// );

// const IconTile = ({ icon: Icon, size = "md" }) => (
//   <div
//     className={`inline-flex flex-shrink-0 items-center justify-center rounded-xl bg-[#f1ecfa] text-[#48247f] transition-all duration-300 group-hover:-rotate-6 group-hover:bg-gradient-to-br group-hover:from-[#48247f] group-hover:to-[#702cb0] group-hover:text-white ${
//       size === "lg" ? "h-14 w-14" : "h-12 w-12"
//     }`}
//   >
//     <Icon className={size === "lg" ? "h-7 w-7" : "h-6 w-6"} />
//   </div>
// );

// const CARD =
//   "group relative overflow-hidden rounded-2xl border border-[#48247f]/10 bg-white shadow-[0_8px_30px_-12px_rgba(72,36,127,0.25)] transition-all duration-300 hover:-translate-y-1 hover:border-[#702cb0]/40 hover:shadow-[0_24px_48px_-12px_rgba(72,36,127,0.4)] motion-reduce:transition-none motion-reduce:hover:translate-y-0";

// const ACCENT_BAR =
//   "absolute left-0 top-0 h-1 w-full origin-left scale-x-0 bg-gradient-to-r from-[#12dfbd] via-[#702cb0] to-[#48247f] transition-transform duration-500 ease-out group-hover:scale-x-100";

// // Decorative concentric rings used behind the hero (hero uses rings, unlike the other solution pages)
// const Rings = () => (
//   <svg
//     aria-hidden="true"
//     viewBox="0 0 600 600"
//     className="pointer-events-none absolute -left-40 -top-32 -z-10 h-[560px] w-[560px] text-[#702cb0] sm:-left-24"
//     fill="none"
//     stroke="currentColor"
//   >
//     {[90, 150, 210, 270].map((r, i) => (
//       <circle key={r} cx="300" cy="300" r={r} strokeOpacity={0.16 - i * 0.03} strokeWidth="1.2" />
//     ))}
//     <circle cx="300" cy="210" r="5" fill="#12dfbd" stroke="none" opacity=".8" />
//     <circle cx="510" cy="300" r="4" fill="#702cb0" stroke="none" opacity=".5" />
//   </svg>
// );

// const JourneyChip = ({ icon: Icon, label, dup = false }) => (
//   <li
//     aria-hidden={dup ? "true" : undefined}
//     className={`${dup ? "edu-dup " : ""}mx-2 inline-flex flex-shrink-0 items-center gap-3 whitespace-nowrap rounded-2xl border border-[#48247f]/10 bg-white px-5 py-3 text-sm font-medium text-[#28194f] shadow-sm sm:text-base`}
//   >
//     <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#f1ecfa] text-[#48247f]">
//       <Icon className="h-4 w-4" />
//     </span>
//     {label}
//   </li>
// );

// const Education = () => {
//   const reduced = useReducedMotion();
//   const item = reduced ? undefined : fadeUp;
//   const group = reduced ? undefined : stagger;
//   const initial = reduced ? false : "hidden";

//   return (
//     <>
//       <Seo title={TITLE} description={DESCRIPTION} path={PATH} jsonLd={JSON_LD} />
//       <style>{MARQUEE_CSS}</style>

//       <div className="w-full overflow-x-clip bg-white font-sans text-[#28194f] antialiased">
//         {/* ================= HERO (soft lavender fade with concentric rings) ================= */}
//         <section
//           id="education-hero"
//           aria-labelledby="education-heading"
//           className="relative isolate w-full overflow-hidden bg-gradient-to-b from-[#f6f3fc] via-white to-white"
//         >
//           <Rings />
//           <div className="pointer-events-none absolute -bottom-24 right-0 -z-10 h-96 w-96 rounded-full bg-[#12dfbd]/15 blur-3xl" />

//           <div className="relative z-10 mx-auto grid w-full max-w-[1500px] items-center gap-10 px-4 pb-14 pt-24 sm:gap-12 sm:px-10 sm:pb-16 sm:pt-28 lg:grid-cols-2 lg:gap-14 lg:px-14 lg:pb-20 lg:pt-32 xl:px-20">
//             <motion.div
//               initial={initial}
//               animate="visible"
//               variants={group}
//               className="mx-auto max-w-xl text-center lg:mx-0 lg:text-left"
//             >
//               <motion.div variants={item}>
//                 <Pill icon={BookOpenCheck}>LMSBOTS for Modern EdTech</Pill>
//               </motion.div>

//               <motion.h1
//                 id="education-heading"
//                 variants={item}
//                 className="text-balance text-[28px] font-light leading-[1.25] tracking-tight sm:text-[34px] lg:text-[38px] xl:text-[42px]"
//               >
//                 Enroll smarter,{" "}
//                 <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
//                   engage faster
//                 </span>
//               </motion.h1>

//               <motion.p
//                 variants={item}
//                 className="mx-auto mt-4 max-w-[540px] text-sm font-light leading-[1.75] text-[#3b2a63] sm:text-base lg:mx-0 lg:text-[17px]"
//               >
//                 Turn every inquiry into a lifelong learner. LMSBOTS automates outreach, tracks student
//                 engagement, and accelerates enrollment, all from a single platform.
//               </motion.p>

//               <motion.div
//                 variants={item}
//                 className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-center lg:justify-start lg:gap-4"
//               >
//                 <Link
//                   to="/contact"
//                   className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-[#12dfbd] px-6 py-3 text-xs font-semibold text-[#102b37] shadow-lg shadow-[#12dfbd]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#40f0d3] hover:shadow-[#12dfbd]/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
//                 >
//                   Get a Platform Demo
//                   <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
//                 </Link>
//                 <Link
//                   to="/features"
//                   className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-[#48247f]/20 bg-white px-6 py-3 text-xs font-medium text-[#48247f] shadow-sm transition-all duration-300 hover:border-[#702cb0]/50 hover:bg-[#f1ecfa] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
//                 >
//                   Explore Features
//                 </Link>
//               </motion.div>

//               <motion.ul
//                 variants={item}
//                 className="mt-8 flex flex-wrap items-center justify-center gap-x-5 gap-y-2.5 lg:justify-start"
//               >
//                 {HERO_POINTS.map((p) => (
//                   <li key={p} className="inline-flex items-center gap-2 text-xs font-medium text-[#3b2a63] sm:text-sm">
//                     <CheckCircle2 className="h-4 w-4 text-[#0f9d86]" strokeWidth={2.5} />
//                     {p}
//                   </li>
//                 ))}
//               </motion.ul>
//             </motion.div>

//             {/* Hero image — simple & plain, matching Technology */}
//             <motion.div
//               initial={reduced ? false : { opacity: 0, y: 30 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.7, ease: "easeOut" }}
//               className="relative mx-auto w-full max-w-[600px] px-3 pb-6 pt-3 lg:max-w-none"
//             >
//               {/* Plain tinted block sits below the image */}
//               <div className="absolute inset-x-8 bottom-0 top-10 rounded-3xl bg-[#e3faf5]" />
//               <div className="relative rounded-2xl bg-white p-2 shadow-xl ring-1 ring-slate-200">
//                 <img
//                   src={EducationImage}
//                   alt="Students learning with technology, supported by LMSBOTS education CRM for admissions and enrollment"
//                   width="1200"
//                   height="800"
//                   fetchpriority="high"
//                   decoding="async"
//                   className="h-auto w-full rounded-xl border border-slate-200 object-cover"
//                 />
//               </div>
//             </motion.div>
//           </div>
//         </section>

//         {/* ================= FEATURES ================= */}
//         <section
//           id="education-features"
//           aria-labelledby="education-features-heading"
//           className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
//         >
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="education-features-heading"
//               pill="Key Features"
//               icon={Settings}
//               before="Intelligent pipeline"
//               highlight="for institutes"
//               text="From the first click to the classroom, manage every prospective student with precision using automation."
//             />

//             <motion.ul
//               variants={group}
//               initial={initial}
//               whileInView="visible"
//               viewport={{ once: true, margin: "-80px" }}
//               className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6"
//             >
//               {FEATURES.map((f, i) => (
//                 <motion.li key={f.title} variants={item} className={`${CARD} p-6`}>
//                   <div className={ACCENT_BAR} />
//                   <div className="mb-5 flex items-start justify-between">
//                     <IconTile icon={f.icon} />
//                     <span className="text-3xl font-light leading-none text-[#48247f]/15 transition-colors duration-300 group-hover:text-[#12dfbd]">
//                       {String(i + 1).padStart(2, "0")}
//                     </span>
//                   </div>
//                   <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{f.title}</h3>
//                   <p className="text-sm leading-[1.7] text-slate-700">{f.desc}</p>
//                 </motion.li>
//               ))}
//             </motion.ul>
//           </div>
//         </section>

//         {/* ================= WHO IT'S FOR ================= */}
//         <section
//           id="education-audience"
//           aria-labelledby="education-audience-heading"
//           className="relative isolate w-full overflow-hidden bg-[#f6f3fc] py-14 sm:py-16 lg:py-24"
//         >
//           <div className="pointer-events-none absolute -right-24 -top-24 -z-10 h-96 w-96 rounded-full bg-[#702cb0]/10 blur-3xl" />
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="education-audience-heading"
//               pill="Who It's For"
//               icon={Users}
//               before="Built for every"
//               highlight="admissions team"
//               text="Whether you run one coaching centre or a multi-campus university, LMSBOTS fits the way you attract and enroll students."
//             />

//             <motion.ul
//               variants={group}
//               initial={initial}
//               whileInView="visible"
//               viewport={{ once: true, margin: "-80px" }}
//               className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6"
//             >
//               {AUDIENCE.map((a) => (
//                 <motion.li key={a.title} variants={item} className={`${CARD} p-6`}>
//                   <div className={ACCENT_BAR} />
//                   <div className="mb-4">
//                     <IconTile icon={a.icon} />
//                   </div>
//                   <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{a.title}</h3>
//                   <p className="text-sm leading-[1.7] text-slate-700">{a.desc}</p>
//                 </motion.li>
//               ))}
//             </motion.ul>
//           </div>
//         </section>

//         {/* ================= LEARNER'S JOURNEY AUTOMATION ================= */}
//         <section
//           id="education-automation"
//           aria-labelledby="education-automation-heading"
//           className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
//         >
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="education-automation-heading"
//               pill="Workflow Automation"
//               icon={RefreshCw}
//               before="Automate the"
//               highlight="learner's journey"
//               text="Timely, personal outreach at every stage of the admissions funnel, without manual chasing."
//             />

//             <motion.ul
//               variants={group}
//               initial={initial}
//               whileInView="visible"
//               viewport={{ once: true, margin: "-80px" }}
//               className="grid grid-cols-1 gap-5 md:grid-cols-3 lg:gap-8"
//             >
//               {JOURNEY_CARDS.map((c) => (
//                 <motion.li key={c.title} variants={item} className={`${CARD} p-6 sm:p-8`}>
//                   <div className={ACCENT_BAR} />
//                   <div className="mb-5">
//                     <IconTile icon={c.icon} size="lg" />
//                   </div>
//                   <h3 className="mb-3 text-xl font-medium tracking-tight text-[#28194f]">{c.title}</h3>
//                   <p className="text-sm leading-[1.75] text-slate-700 sm:text-[15px]">{c.desc}</p>
//                 </motion.li>
//               ))}
//             </motion.ul>
//           </div>
//         </section>

//         {/* ================= ADMISSIONS WORKFLOW ================= */}
//         <section
//           id="education-workflow"
//           aria-labelledby="education-workflow-heading"
//           className="relative isolate w-full overflow-hidden border-y border-[#48247f]/10 bg-[#f6f3fc] py-14 sm:py-16 lg:py-24"
//         >
//           <div className="pointer-events-none absolute -bottom-24 -left-24 -z-10 h-96 w-96 rounded-full bg-[#12dfbd]/15 blur-3xl" />
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="education-workflow-heading"
//               pill="Admissions Workflow"
//               icon={ClipboardCheck}
//               before="From"
//               highlight="inquiry to enrolled student"
//               after="in 4 steps"
//               text="A clear, automated path that keeps every applicant, and every counsellor, on track."
//             />

//             <motion.ol
//               variants={group}
//               initial={initial}
//               whileInView="visible"
//               viewport={{ once: true, margin: "-80px" }}
//               className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4 lg:gap-6"
//             >
//               {STEPS.map((w, i) => (
//                 <motion.li key={w.title} variants={item} className={`${CARD} h-full p-6`}>
//                   <div className={ACCENT_BAR} />
//                   <div className="mb-5 flex items-start justify-between">
//                     <IconTile icon={w.icon} />
//                     <span className="text-3xl font-light leading-none text-[#48247f]/15 transition-colors duration-300 group-hover:text-[#12dfbd]">
//                       {String(i + 1).padStart(2, "0")}
//                     </span>
//                   </div>
//                   <h3 className="mb-4 text-lg font-medium tracking-tight text-[#28194f]">{w.title}</h3>
//                   <ul className="space-y-2.5">
//                     {w.steps.map((s) => (
//                       <li key={s} className="flex items-start gap-2.5 text-sm text-slate-700">
//                         <CheckCircle2 className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#0f9d86]" strokeWidth={2.5} />
//                         <span>{s}</span>
//                       </li>
//                     ))}
//                   </ul>
//                 </motion.li>
//               ))}
//             </motion.ol>
//           </div>
//         </section>

//         {/* ================= CONVERSATION FLOW (MARQUEE) ================= */}
//         <section
//           id="education-conversations"
//           aria-labelledby="education-conversations-heading"
//           className="relative w-full overflow-hidden bg-white py-14 sm:py-16 lg:py-24"
//         >
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="education-conversations-heading"
//               pill="Student Conversations"
//               before="Turn workflows into"
//               highlight="conversations"
//               text="Every interaction is a chance to build trust. See how LMSBOTS guides prospects naturally through the admissions funnel."
//             />
//           </div>

//           <div className="edu-pause relative space-y-4" role="group" aria-label="Examples of admissions funnel touchpoints">
//             <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-white to-transparent sm:w-32" />
//             <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-white to-transparent sm:w-32" />

//             {[
//               { list: JOURNEY_1, dir: "edu-right" },
//               { list: JOURNEY_2, dir: "edu-left" },
//             ].map(({ list, dir }) => (
//               <div key={dir} className="overflow-hidden">
//                 <ul className={`edu-track ${dir}`}>
//                   {list.map((j) => (
//                     <JourneyChip key={j.label} {...j} />
//                   ))}
//                   {/* Duplicate set makes the loop seamless; hidden from assistive tech and reduced-motion users */}
//                   {list.map((j) => (
//                     <JourneyChip key={`dup-${j.label}`} dup {...j} />
//                   ))}
//                 </ul>
//               </div>
//             ))}
//           </div>

//           <div className="mt-10 text-center">
//             <Link
//               to="/contact"
//               className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-[#48247f] to-[#702cb0] px-7 py-3 text-xs font-semibold text-white shadow-lg shadow-[#48247f]/25 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[#48247f]/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
//             >
//               Start Your Journey
//               <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
//             </Link>
//           </div>
//         </section>

//         {/* ================= LEAD SCORING ================= */}
//         <section
//           id="education-scoring"
//           aria-labelledby="education-scoring-heading"
//           className="relative isolate w-full overflow-hidden border-t border-[#48247f]/10 bg-[#f6f3fc] py-14 sm:py-16 lg:py-24"
//         >
//           <div className="pointer-events-none absolute -right-24 top-0 -z-10 h-96 w-96 rounded-full bg-[#702cb0]/10 blur-3xl" />
//           <div className="mx-auto grid w-full max-w-[1300px] items-center gap-10 px-4 sm:px-10 lg:grid-cols-2 lg:gap-16 lg:px-14">
//             <motion.div
//               variants={group}
//               initial={initial}
//               whileInView="visible"
//               viewport={{ once: true, margin: "-80px" }}
//               className="text-center lg:text-left"
//             >
//               <motion.div variants={item}>
//                 <Pill icon={Target}>Lead Scoring &amp; Analytics</Pill>
//               </motion.div>
//               <motion.h2
//                 id="education-scoring-heading"
//                 variants={item}
//                 className="text-balance text-[26px] font-light leading-[1.25] tracking-tight sm:text-[34px] lg:text-[38px]"
//               >
//                 Identify your{" "}
//                 <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
//                   next student
//                 </span>{" "}
//                 before they apply
//               </motion.h2>
//               <motion.p
//                 variants={item}
//                 className="mt-4 text-[15px] leading-[1.75] text-[#3b2a63] sm:text-base"
//               >
//                 Lead scoring looks at behavior, engagement, and applicant profile to show exactly who
//                 is ready to enroll, so your admissions team can focus its time where it counts.
//               </motion.p>

//               <motion.ul variants={item} className="mx-auto mt-6 max-w-md space-y-3 text-left lg:mx-0">
//                 {SCORING_POINTS.map((t) => (
//                   <li key={t} className="flex items-start gap-3 text-sm font-medium text-[#28194f] sm:text-[15px]">
//                     <CheckCircle2 className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#0f9d86]" strokeWidth={2.5} />
//                     {t}
//                   </li>
//                 ))}
//               </motion.ul>

//               <motion.div variants={item} className="mt-8">
//                 <Link
//                   to="/features"
//                   className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg border border-[#48247f]/20 bg-white px-6 py-3 text-xs font-medium text-[#48247f] shadow-sm transition-all duration-300 hover:border-[#702cb0]/50 hover:bg-[#f1ecfa] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
//                 >
//                   Explore CRM Analytics
//                   <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
//                 </Link>
//               </motion.div>
//             </motion.div>

//             {/* Signals panel (describes what scoring considers; no sample numbers) */}
//             <motion.div
//               initial={reduced ? false : { opacity: 0, y: 30 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true, margin: "-80px" }}
//               transition={{ duration: 0.7, ease: "easeOut" }}
//               className="relative overflow-hidden rounded-3xl border border-[#48247f]/10 bg-white p-6 shadow-[0_24px_60px_-20px_rgba(72,36,127,0.35)] sm:p-8"
//             >
//               <div className="absolute left-0 top-0 h-1 w-full bg-gradient-to-r from-[#12dfbd] via-[#702cb0] to-[#48247f]" />
//               <div className="mb-5 flex items-center gap-3">
//                 <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#f1ecfa] text-[#48247f]">
//                   <TrendingUp className="h-5 w-5" />
//                 </span>
//                 <div>
//                   <h3 className="text-base font-medium text-[#28194f] sm:text-lg">What the score looks at</h3>
//                   <p className="text-xs text-slate-600">Signals combined for every applicant</p>
//                 </div>
//               </div>

//               <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2">
//                 {SCORING_SIGNALS.map(({ icon: Icon, label }) => (
//                   <li
//                     key={label}
//                     className="flex items-center gap-3 rounded-xl border border-[#48247f]/10 bg-[#fbf9ff] px-4 py-3 text-sm font-medium text-[#28194f]"
//                   >
//                     <Icon className="h-4 w-4 flex-shrink-0 text-[#702cb0]" />
//                     {label}
//                   </li>
//                 ))}
//               </ul>

//               <div className="mt-5 flex items-center gap-2 rounded-xl bg-[#e3faf5] px-4 py-3 text-sm font-medium text-[#0b6b5a]">
//                 <Zap className="h-4 w-4 flex-shrink-0" />
//                 High-priority applicants are routed to a counsellor automatically.
//               </div>
//             </motion.div>
//           </div>
//         </section>

//         {/* ================= FAQ ================= */}
//         <section
//           id="education-faq"
//           aria-labelledby="education-faq-heading"
//           className="relative isolate w-full overflow-hidden bg-white py-14 sm:py-16 lg:py-24"
//         >
//           <div className="pointer-events-none absolute -bottom-24 -left-24 -z-10 h-96 w-96 rounded-full bg-[#12dfbd]/15 blur-3xl" />
//           <div className="mx-auto w-full max-w-[900px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="education-faq-heading"
//               pill="FAQ"
//               before="Education CRM"
//               highlight="questions answered"
//             />

//             <div className="space-y-4">
//               {FAQS.map(({ q, a }, i) => (
//                 <details
//                   key={q}
//                   open={i === 0}
//                   className="group overflow-hidden rounded-2xl border border-[#48247f]/10 bg-white shadow-[0_8px_30px_-14px_rgba(72,36,127,0.25)] transition-colors open:border-[#702cb0]/40"
//                 >
//                   <summary className="flex min-h-[64px] cursor-pointer list-none items-center justify-between gap-4 px-5 py-4 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#702cb0] sm:px-6 [&::-webkit-details-marker]:hidden">
//                     <h3 className="flex-1 text-[15px] font-medium leading-snug text-[#28194f] sm:text-base">{q}</h3>
//                     <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#f1ecfa] text-[#48247f] transition-all duration-300 group-open:rotate-180 group-open:bg-[#12dfbd] group-open:text-[#102b37]">
//                       <ChevronDown className="h-5 w-5" />
//                     </span>
//                   </summary>
//                   <p className="px-5 pb-6 text-sm leading-[1.75] text-slate-700 sm:px-6 sm:text-[15px]">{a}</p>
//                 </details>
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* ================= CLOSING CTA ================= */}
//         <section
//           aria-labelledby="education-cta-heading"
//           className="w-full bg-white px-4 pb-10 sm:px-10 sm:pb-12 lg:px-14 lg:pb-16"
//         >
//           <div className="relative isolate mx-auto w-full max-w-[1300px] overflow-hidden rounded-[1.5rem] border border-[#48247f]/10 bg-gradient-to-br from-[#f1ecfa] via-white to-[#f6f3fc] px-5 py-12 text-center shadow-[0_20px_60px_-20px_rgba(72,36,127,0.25)] sm:rounded-[2rem] sm:px-12 sm:py-16">
//             <div className="pointer-events-none absolute -bottom-20 -right-20 -z-10 h-72 w-72 rounded-full bg-[#12dfbd]/20 blur-3xl" />
//             <h2
//               id="education-cta-heading"
//               className="mx-auto max-w-2xl text-balance text-[26px] font-light leading-[1.25] tracking-tight sm:text-[34px]"
//             >
//               Ready to{" "}
//               <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
//                 grow your enrollments?
//               </span>
//             </h2>
//             <p className="mx-auto mt-4 max-w-[560px] text-[15px] leading-[1.75] text-[#3b2a63] sm:text-base">
//               See how LMSBOTS fits your admissions process. In a live demo we'll cover inquiry
//               capture, counsellor routing, follow-up automation, fee reminders, and reporting.
//             </p>
//             <div className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
//               <Link
//                 to="/contact"
//                 className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-[#12dfbd] px-7 py-3 text-xs font-semibold text-[#102b37] shadow-lg shadow-[#12dfbd]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#40f0d3] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
//               >
//                 Get a Platform Demo
//                 <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
//               </Link>
//               <Link
//                 to="/pricing"
//                 className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-[#48247f]/20 bg-white px-7 py-3 text-xs font-medium text-[#48247f] shadow-sm transition-all duration-300 hover:border-[#702cb0]/50 hover:bg-[#f1ecfa] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
//               >
//                 View Pricing
//               </Link>
//             </div>
//           </div>
//         </section>
//       </div>
//     </>
//   );
// };

// export default Education;








import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import {
  GraduationCap,
  IndianRupee,
  Phone,
  FileText,
  Upload,
  CheckCircle2,
  CreditCard,
  BookOpenCheck,
  TrendingUp,
  ArrowRight,
  ChevronDown,
  Users,
  MessageCircle,
  BarChart3,
  Target,
  Calendar,
  Award,
  Rocket,
  ClipboardCheck,
  School,
  Laptop,
  Building2,
  RefreshCw,
  HelpCircle,
  BookOpen,
} from "lucide-react";
import EducationImage from "../../assets/education.jpg";
// NOTE: adjust this path to wherever Seo.js lives in your project
import Seo, { SITE_URL } from "../../WebsiteComponents/Seo";
import { ROUTES } from "../../seoData";

const PATH = "/solutions/education";
const TITLE = ROUTES?.[PATH]?.title || "Education CRM & Admission Lead Management | LMSBOTS";
const DESCRIPTION =
  ROUTES?.[PATH]?.description ||
  "LMSBOTS Education CRM helps colleges, coaching institutes and EdTech teams capture student inquiries, route them to counsellors, automate follow-ups and fee reminders, and boost enrollments.";

const JSON_LD = [
  {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "LMSBOTS Education CRM",
    applicationCategory: "BusinessApplication",
    applicationSubCategory: "Education CRM / Admission Lead Management",
    operatingSystem: "Web, Android, iOS",
    description: DESCRIPTION,
    url: `${SITE_URL}${PATH}`,
    publisher: { "@id": `${SITE_URL}/#organization` },
    featureList: [
      "Omnichannel student inquiry capture",
      "Intelligent counsellor routing & scheduling",
      "Automated WhatsApp, SMS, and email drip sequences",
      "Predictive lead scoring & behavioral analytics",
      "Automated fee payment reminders & invoicing",
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
      { "@type": "ListItem", position: 2, name: "Solutions", item: `${SITE_URL}/solutions` },
      { "@type": "ListItem", position: 3, name: "Education", item: `${SITE_URL}${PATH}` },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "What is an education CRM?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "An education CRM is specialized software that helps colleges, coaching institutes, and EdTech companies capture student inquiries, assign them to counsellors, automate follow-ups, track applications and documents, and manage fee payments until the student is successfully enrolled.",
        },
      },
      {
        "@type": "Question",
        name: "Where can LMSBOTS capture student inquiries from?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "LMSBOTS captures inquiries from website forms, landing pages, social media lead generation campaigns, direct phone calls, WhatsApp chats, and walk-in enquiries into a unified dashboard.",
        },
      },
      {
        "@type": "Question",
        name: "How does predictive lead scoring work for admissions?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Our predictive lead scoring analyzes student interactions across emails, course page visits, SMS replies, and demographic profiles to prioritize high-intent applicants so your admission team can focus on closing ready candidates.",
        },
      },
    ],
  },
];

// ---------- Static content (outside the component so it isn't rebuilt on every render) ----------
const HERO_POINTS = ["Inquiry capture", "Counsellor routing", "Fee reminders"];

const FEATURES = [
  {
    icon: Users,
    title: "Omnichannel Lead Capture",
    desc: "Automatically bring inquiries from web forms, social campaigns, direct chats, and calls into one unified dashboard.",
  },
  {
    icon: Target,
    title: "Lead Scoring",
    desc: "Prioritize high-intent applicants with scoring based on behavior, course interest, and demographic profile.",
  },
  {
    icon: MessageCircle,
    title: "Automated Nurture Sequences",
    desc: "Run customized email, SMS, and WhatsApp drip campaigns that keep prospects engaged throughout the admission cycle.",
  },
  {
    icon: BarChart3,
    title: "Enrollment Analytics",
    desc: "Follow performance from first inquiry to final fee payment with visual pipelines and conversion reporting.",
  },
];

const AUDIENCE = [
  {
    icon: GraduationCap,
    title: "Colleges & universities",
    desc: "Manage program-wise inquiries, counsellor allocation, and application deadlines in one place.",
  },
  {
    icon: School,
    title: "Coaching & training institutes",
    desc: "Handle batch-wise inquiries, demo-class bookings, and fee follow-ups without spreadsheets.",
  },
  {
    icon: Laptop,
    title: "EdTech platforms",
    desc: "Turn sign-ups, free trials, and webinar registrants into paying learners with timely nurturing.",
  },
  {
    icon: Building2,
    title: "Study-abroad & admission consultants",
    desc: "Track every student's documents, applications, and counsellor conversations from inquiry to visa.",
  },
];

const JOURNEY_CARDS = [
  {
    icon: GraduationCap,
    title: "From Inquiry to Enrollment",
    desc: "Automated welcome sequences, document reminders, and counsellor scheduling keep applicants moving forward.",
  },
  {
    icon: TrendingUp,
    title: "Real-time Engagement Alerts",
    desc: "Know when a lead opens your email or revisits a course page, then trigger a follow-up while intent is high.",
  },
  {
    icon: IndianRupee,
    title: "Automated Payment Reminders",
    desc: "Reduce drop-offs with scheduled fee reminders, installment-plan nudges, and deadline alerts.",
  },
];

const STEPS = [
  {
    icon: Users,
    title: "Inquiry Captured",
    steps: ["Website & landing pages", "Social campaigns", "Calls & chats", "Walk-in inquiries"],
  },
  {
    icon: Phone,
    title: "Counsellor Assigned",
    steps: ["Program-based routing", "Instant notification", "Call scheduling", "Interaction history"],
  },
  {
    icon: FileText,
    title: "Application & Documents",
    steps: ["Application tracking", "Document requests", "Verification status", "Deadline reminders"],
  },
  {
    icon: Rocket,
    title: "Enrollment & Onboarding",
    steps: ["Fee payment links", "Installment reminders", "Enrollment confirmation", "Student onboarding"],
  },
];

const SCORING_POINTS = [
  "Engagement tracking across email, SMS, and your portal",
  "Scoring rules tailored to specific programs",
  "Automatic routing for high-priority applicants",
];

const JOURNEY_1 = [
  { icon: ClipboardCheck, label: "Intake assessment" },
  { icon: Phone, label: "Counsellor routing" },
  { icon: FileText, label: "Application tracking" },
  { icon: Upload, label: "Document verification" },
  { icon: CheckCircle2, label: "Enrollment status" },
  { icon: CreditCard, label: "Automated invoicing" },
  { icon: Rocket, label: "Student onboarding" },
];

const JOURNEY_2 = [
  { icon: Calendar, label: "Campus visit booking" },
  { icon: Award, label: "Scholarship queries" },
  { icon: MessageCircle, label: "Welcome sequence" },
  { icon: IndianRupee, label: "Fee reminders" },
  { icon: Target, label: "High-intent alert" },
  { icon: Users, label: "Referral inquiries" },
  { icon: RefreshCw, label: "Re-engagement campaign" },
];

const EDUCATION_BLOGS = [
  {
    tag: "Enrollment Strategy",
    title: "How EdTech Platforms Increase Admissions by 40% Using Automated WhatsApp Drips",
    readTime: "5 min read",
    summary:
      "Learn how instant mobile engagement, automated demo reminders, and personalized WhatsApp messages eliminate lead drop-offs during peak admission cycles.",
  },
  {
    tag: "Admissions Optimization",
    title: "Predictive Lead Scoring: Identifying High-Intent Students Before They Apply",
    readTime: "6 min read",
    summary:
      "Discover how tracking student interactions across course landing pages, fee queries, and email opens allows counselling teams to focus on ready applicants.",
  },
  {
    tag: "Institutional Growth",
    title: "Streamlining Document Verification & Fee Reminders in Higher Education CRMs",
    readTime: "4 min read",
    summary:
      "A complete guide to removing administrative friction from application submission to final fee confirmation with automated multi-channel sequences.",
  },
];

const FAQS = [
  {
    q: "What is an education CRM?",
    a: "An education CRM is software that helps colleges, institutes, and EdTech companies capture student inquiries, assign them to counsellors, automate follow-ups, track applications and documents, and manage fee payments until the student is enrolled.",
  },
  {
    q: "Where can LMSBOTS capture student inquiries from?",
    a: "LMSBOTS captures inquiries from website forms, landing pages, social media lead generation campaigns, direct phone calls, WhatsApp chats, and walk-in enquiries into a unified dashboard.",
  },
  {
    q: "How does predictive lead scoring work for admissions?",
    a: "Our predictive lead scoring analyzes student interactions across emails, course page visits, SMS replies, and demographic profiles to prioritize high-intent applicants so your admission team can focus on closing ready candidates.",
  },
  {
    q: "Can LMSBOTS automate fee payment reminders?",
    a: "Yes. You can configure automated fee reminder workflows via WhatsApp, SMS, and email with scheduled payment links and installment notifications to drastically reduce payment drop-offs.",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const stagger = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.15 } },
};

const SectionHeading = ({ id, pill, before, highlight }) => (
  <div className="mx-auto mb-12 max-w-3xl text-center lg:mb-16">
    <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-[#48247f]/15 bg-white px-3 py-1 text-xs font-medium text-[#48247f] shadow-sm">
      <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#12dfbd]" />
      {pill}
    </div>
    <h2
      id={id}
      className="text-balance text-[26px] font-light leading-[1.25] tracking-tight text-[#28194f] sm:text-[34px] lg:text-[38px]"
    >
      {before}{" "}
      <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
        {highlight}
      </span>
    </h2>
    <div className="mx-auto mt-6 h-1 w-24 rounded-full bg-gradient-to-r from-[#12dfbd] via-[#702cb0] to-[#48247f]" />
  </div>
);

const Education = () => {
  const reduced = useReducedMotion();
  const item = reduced ? undefined : fadeUp;
  const group = reduced ? undefined : stagger;
  const initial = reduced ? false : "hidden";

  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <>
      <Seo title={TITLE} description={DESCRIPTION} path={PATH} jsonLd={JSON_LD} />

      <style>{`
        @keyframes scroll-left {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes scroll-right {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
        .animate-scroll-left {
          display: flex;
          width: max-content;
          animation: scroll-left 30s linear infinite;
        }
        .animate-scroll-right {
          display: flex;
          width: max-content;
          animation: scroll-right 30s linear infinite;
        }
        .animate-scroll-left:hover, .animate-scroll-right:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="w-full overflow-x-clip bg-white font-sans text-[#28194f] antialiased">
        {/* ===== HERO SECTION ===== */}
        <section
          id="education-hero"
          aria-labelledby="education-heading"
          className="relative isolate w-full overflow-hidden bg-gradient-to-br from-[#fbf7ff] via-white to-[#effbf8]"
        >
          <div className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-[#702cb0]/10 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 -left-24 h-96 w-96 rounded-full bg-[#12dfbd]/15 blur-3xl" />

          <div className="relative z-10 mx-auto grid w-full max-w-[1500px] items-center gap-10 px-4 pb-14 pt-24 sm:gap-12 sm:px-10 sm:pb-16 sm:pt-28 lg:grid-cols-[1fr_1fr] lg:gap-14 lg:px-14 lg:pb-20 lg:pt-32 xl:px-20">
            {/* Left content */}
            <motion.div
              initial={initial}
              animate="visible"
              variants={group}
              className="mx-auto max-w-xl text-center lg:mx-0 lg:text-left"
            >
              <motion.div
                variants={item}
                className="mb-6 inline-flex items-center gap-2 rounded-full border border-[#48247f]/15 bg-white px-3 py-1 text-xs font-medium text-[#48247f] shadow-sm"
              >
                <BookOpenCheck className="h-3.5 w-3.5 text-[#702cb0]" />
                LMSBOTS For Modern EdTech &amp; Institutes
              </motion.div>

              <motion.h1
                id="education-heading"
                variants={item}
                className="text-balance text-[28px] font-light leading-[1.25] tracking-tight sm:text-[34px] lg:text-[38px] xl:text-[42px]"
              >
                Enroll smarter,{" "}
                <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
                  engage faster.
                </span>
              </motion.h1>

              <motion.p
                variants={item}
                className="mx-auto mt-4 max-w-[540px] text-sm font-light leading-[1.75] text-[#3b2a63] sm:text-base lg:mx-0 lg:text-[17px]"
              >
                Turn every inquiry into a lifelong learner. Our comprehensive CRM automates outreach, tracks student engagement, and accelerates enrollment—all within a single intelligent architecture.
              </motion.p>

              <motion.div
                variants={item}
                className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-center lg:justify-start lg:gap-4"
              >
                <Link
                  to="/contact"
                  className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-[#12dfbd] px-6 py-3 text-xs font-semibold text-[#102b37] shadow-lg shadow-[#12dfbd]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#40f0d3] hover:shadow-[#12dfbd]/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
                >
                  Get a Platform Demo
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
                <Link
                  to="/features"
                  className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-[#48247f]/20 bg-white px-6 py-3 text-xs font-medium text-[#48247f] shadow-sm transition-all duration-300 hover:border-[#702cb0]/50 hover:bg-[#f1ecfa] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
                >
                  Explore Features
                </Link>
              </motion.div>

              <motion.ul
                variants={item}
                className="mt-8 flex flex-wrap items-center justify-center gap-x-5 gap-y-2.5 lg:justify-start"
              >
                {HERO_POINTS.map((p) => (
                  <li key={p} className="inline-flex items-center gap-2 text-xs font-medium text-[#3b2a63] sm:text-sm">
                    <CheckCircle2 className="h-4 w-4 text-[#0f9d86]" strokeWidth={2.5} />
                    {p}
                  </li>
                ))}
              </motion.ul>
            </motion.div>

            {/* Right image */}
            <motion.div
              initial={reduced ? false : { opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              className="relative mx-auto w-full max-w-[600px] px-3 pb-6 pt-3 lg:max-w-none"
            >
              <div className="absolute inset-x-8 bottom-0 top-10 rounded-3xl bg-[#e3faf5]" />
              <div className="relative rounded-2xl bg-white p-2 shadow-xl ring-1 ring-slate-200">
                <img
                  src={EducationImage}
                  alt="Students learning with technology and managing admissions on LMSBOTS education CRM"
                  width="1200"
                  height="800"
                  fetchpriority="high"
                  decoding="async"
                  className="h-auto w-full rounded-xl border border-slate-200 object-cover"
                />
              </div>
            </motion.div>
          </div>
        </section>

        {/* ===== TARGET AUDIENCE SECTION ===== */}
        <section
          id="education-audience"
          aria-labelledby="education-audience-heading"
          className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <motion.div
              initial={reduced ? false : { opacity: 0, y: -20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <SectionHeading
                id="education-audience-heading"
                pill="Built For All Institutions"
                before="Tailored solutions for"
                highlight="every educational model"
              />
            </motion.div>

            <motion.div
              variants={group}
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
              className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4 lg:gap-8"
            >
              {AUDIENCE.map(({ icon: Icon, title, desc }) => (
                <motion.div
                  key={title}
                  variants={item}
                  className="group relative flex flex-col overflow-hidden rounded-2xl border border-[#48247f]/10 bg-white p-6 shadow-[0_8px_30px_-12px_rgba(72,36,127,0.25)] transition-all duration-300 hover:-translate-y-1 hover:border-[#702cb0]/40 hover:shadow-[0_24px_48px_-12px_rgba(72,36,127,0.4)] motion-reduce:transition-none sm:p-8"
                >
                  <div className="absolute left-0 top-0 h-full w-1 origin-top scale-y-0 bg-gradient-to-b from-[#12dfbd] via-[#702cb0] to-[#48247f] transition-transform duration-500 ease-out group-hover:scale-y-100" />
                  <div className="mb-5 inline-flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-[#f1ecfa] text-[#48247f] transition-all duration-300 group-hover:-rotate-6 group-hover:bg-gradient-to-br group-hover:from-[#48247f] group-hover:to-[#702cb0] group-hover:text-white">
                    <Icon className="h-6 w-6" />
                  </div>
                  <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f] sm:text-xl">
                    {title}
                  </h3>
                  <p className="text-sm font-normal leading-[1.75] text-slate-700">{desc}</p>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </section>

        {/* ===== FEATURES SECTION ===== */}
        <section
          id="education-features"
          aria-labelledby="education-features-heading"
          className="relative w-full border-t border-[#48247f]/10 bg-white py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <motion.div
              initial={reduced ? false : { opacity: 0, y: -20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <SectionHeading
                id="education-features-heading"
                pill="Core Capabilities"
                before="Intelligent pipeline"
                highlight="for institutes"
              />
            </motion.div>

            <motion.ul
              variants={group}
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
              className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:gap-8"
            >
              {FEATURES.map(({ icon: Icon, title, desc }, i) => (
                <motion.li
                  key={title}
                  variants={item}
                  className="group relative flex gap-5 overflow-hidden rounded-2xl border border-[#48247f]/10 bg-white p-6 shadow-[0_8px_30px_-12px_rgba(72,36,127,0.25)] transition-all duration-300 hover:-translate-y-1 hover:border-[#702cb0]/40 hover:shadow-[0_24px_48px_-12px_rgba(72,36,127,0.4)] motion-reduce:transition-none sm:p-8"
                >
                  <div className="absolute left-0 top-0 h-full w-1 origin-top scale-y-0 bg-gradient-to-b from-[#12dfbd] via-[#702cb0] to-[#48247f] transition-transform duration-500 ease-out group-hover:scale-y-100" />
                  <div className="inline-flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-[#f1ecfa] text-[#48247f] transition-all duration-300 group-hover:-rotate-6 group-hover:bg-gradient-to-br group-hover:from-[#48247f] group-hover:to-[#702cb0] group-hover:text-white">
                    <Icon className="h-6 w-6" />
                  </div>
                  <div className="min-w-0">
                    <div className="mb-2 flex items-start justify-between gap-3">
                      <h3 className="text-lg font-medium tracking-tight text-[#28194f] sm:text-xl">
                        {title}
                      </h3>
                      <span className="text-2xl font-light leading-none text-[#48247f]/15 transition-colors duration-300 group-hover:text-[#12dfbd]">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                    </div>
                    <p className="text-sm font-normal leading-[1.75] text-slate-700">{desc}</p>
                  </div>
                </motion.li>
              ))}
            </motion.ul>
          </div>
        </section>

        {/* ===== AUTOMATION WORKFLOWS SECTION ===== */}
        <section
          id="education-workflow"
          aria-labelledby="education-workflow-heading"
          className="relative isolate w-full overflow-hidden border-t border-[#48247f]/10 bg-[#f6f3fc] py-14 sm:py-16 lg:py-24"
        >
          <div className="pointer-events-none absolute -bottom-24 -right-24 -z-10 h-96 w-96 rounded-full bg-[#12dfbd]/15 blur-3xl" />

          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <motion.div
              initial={reduced ? false : { opacity: 0, y: -20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <SectionHeading
                id="education-workflow-heading"
                pill="Learner's Journey"
                before="Automate the"
                highlight="admissions lifecycle"
              />
            </motion.div>

            <div className="grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">
              {JOURNEY_CARDS.map(({ icon: Icon, title, desc }, idx) => (
                <div
                  key={idx}
                  className="group relative overflow-hidden rounded-2xl border border-[#48247f]/10 bg-white p-6 shadow-[0_8px_30px_-12px_rgba(72,36,127,0.25)] transition-all duration-300 hover:-translate-y-1 hover:border-[#702cb0]/40 hover:shadow-[0_24px_48px_-12px_rgba(72,36,127,0.4)] motion-reduce:transition-none sm:p-8"
                >
                  <div className="absolute left-0 top-0 h-full w-1 origin-top scale-y-0 bg-gradient-to-b from-[#12dfbd] via-[#702cb0] to-[#48247f] transition-transform duration-500 ease-out group-hover:scale-y-100" />
                  <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#f1ecfa] text-[#48247f] transition-all duration-300 group-hover:-rotate-6 group-hover:bg-gradient-to-br group-hover:from-[#48247f] group-hover:to-[#702cb0] group-hover:text-white">
                    <Icon className="h-6 w-6" />
                  </div>
                  <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f] sm:text-xl">
                    {title}
                  </h3>
                  <p className="text-sm font-normal leading-[1.75] text-slate-700">{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== STEP-BY-STEP ADMISSIONS FUNNEL ===== */}
        <section
          id="education-funnel"
          aria-labelledby="education-funnel-heading"
          className="relative w-full border-t border-[#48247f]/10 bg-white py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <motion.div
              initial={reduced ? false : { opacity: 0, y: -20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <SectionHeading
                id="education-funnel-heading"
                pill="Pipeline Stages"
                before="Streamlined"
                highlight="admission stages"
              />
            </motion.div>

            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
              {STEPS.map(({ icon: Icon, title, steps }, i) => (
                <div
                  key={title}
                  className="group relative overflow-hidden rounded-2xl border border-[#48247f]/10 bg-white p-6 shadow-[0_8px_30px_-12px_rgba(72,36,127,0.25)] transition-all duration-300 hover:-translate-y-1 hover:border-[#702cb0]/40 hover:shadow-[0_24px_48px_-12px_rgba(72,36,127,0.4)] motion-reduce:transition-none sm:p-8"
                >
                  <div className="absolute left-0 top-0 h-full w-1 origin-top scale-y-0 bg-gradient-to-b from-[#12dfbd] via-[#702cb0] to-[#48247f] transition-transform duration-500 ease-out group-hover:scale-y-100" />
                  <div className="mb-2 flex items-start justify-between gap-3">
                    <div className="inline-flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-[#f1ecfa] text-[#48247f] transition-all duration-300 group-hover:-rotate-6 group-hover:bg-gradient-to-br group-hover:from-[#48247f] group-hover:to-[#702cb0] group-hover:text-white">
                      <Icon className="h-6 w-6" />
                    </div>
                    <span className="text-2xl font-light leading-none text-[#48247f]/15 transition-colors duration-300 group-hover:text-[#12dfbd]">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <h3 className="mb-4 mt-3 text-lg font-medium tracking-tight text-[#28194f] sm:text-xl">{title}</h3>
                  <ul className="space-y-2.5">
                    {steps.map((step, sIdx) => (
                      <li key={sIdx} className="flex items-center gap-2 text-xs text-slate-700 sm:text-sm">
                        <CheckCircle2 className="h-4 w-4 text-[#0f9d86]" />
                        <span>{step}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== LEAD SCORING & ANALYTICS ===== */}
        <section
          id="education-scoring"
          aria-labelledby="education-scoring-heading"
          className="relative w-full border-t border-[#48247f]/10 bg-[#fbf7ff] py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
              <div>
                <span className="mb-4 inline-flex items-center gap-2 rounded-full border border-[#48247f]/15 bg-white px-3 py-1 text-xs font-medium text-[#48247f] shadow-sm">
                  <Target className="h-3.5 w-3.5 text-[#702cb0]" />
                  Predictive Scoring
                </span>
                <h2 className="text-balance text-[28px] font-light leading-[1.25] tracking-tight text-[#28194f] sm:text-[34px] lg:text-[38px]">
                  Identify your <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">next student</span> before they apply
                </h2>
                <p className="mt-4 text-sm font-light leading-[1.75] text-[#3b2a63] sm:text-base">
                  Our predictive lead scoring analyzes behavior, engagement metrics, and applicant demographics to highlight exactly who is ready to enroll—allowing your admissions team to focus resources effectively.
                </p>

                <ul className="mt-6 space-y-3">
                  {SCORING_POINTS.map((text, i) => (
                    <li key={i} className="flex items-start gap-3 text-sm text-slate-700 sm:text-base">
                      <div className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-[#f1ecfa]">
                        <CheckCircle2 className="h-3.5 w-3.5 text-[#702cb0]" />
                      </div>
                      <span>{text}</span>
                    </li>
                  ))}
                </ul>

                <div className="mt-8">
                  <Link
                    to="/contact"
                    className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-[#48247f] to-[#702cb0] px-6 py-3 text-xs font-semibold text-white shadow-lg shadow-[#48247f]/25 transition-all duration-300 hover:-translate-y-0.5 sm:text-sm"
                  >
                    Explore CRM Analytics
                    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                  </Link>
                </div>
              </div>

              <div className="relative mx-auto w-full max-w-[600px]">
                <div className="absolute inset-x-8 bottom-0 top-10 rounded-3xl bg-[#e3faf5]" />
                <div className="relative rounded-2xl bg-white p-2 shadow-xl ring-1 ring-slate-200">
                  <img
                    src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
                    alt="Lead Scoring Dashboard for Education CRM"
                    width="1200"
                    height="800"
                    loading="lazy"
                    className="h-auto w-full rounded-xl border border-slate-200 object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ===== MARQUEE CONVERSATION FLOW ===== */}
        <section
          id="education-marquee"
          aria-labelledby="education-marquee-heading"
          className="relative overflow-hidden border-t border-[#48247f]/10 bg-[#f6f3fc] py-14 text-center sm:py-16 lg:py-24"
        >
          <h2
            id="education-marquee-heading"
            className="text-balance text-[26px] font-light leading-[1.25] tracking-tight text-[#28194f] sm:text-[34px] lg:text-[38px]"
          >
            Turn workflows into <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">conversations</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl px-4 text-sm font-light text-slate-600 sm:text-base">
            Every interaction is an opportunity to build trust. See how our CRM framework guides prospects naturally through the admissions funnel.
          </p>

          <div className="mt-12 space-y-6">
            {/* Left marquee */}
            <div className="relative flex overflow-hidden">
              <div className="animate-scroll-right flex gap-6 w-max">
                {[...JOURNEY_1, ...JOURNEY_1].map((item, i) => {
                  const Icon = item.icon;
                  return (
                    <div
                      key={i}
                      className="flex items-center gap-3 rounded-xl border border-[#48247f]/15 bg-white px-6 py-4 font-medium text-slate-700 shadow-sm transition-all duration-300 hover:border-[#702cb0]/40 hover:shadow-md whitespace-nowrap"
                    >
                      <div className="rounded-lg bg-[#f1ecfa] p-2 text-[#702cb0]">
                        <Icon size={18} />
                      </div>
                      {item.label}
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Right marquee */}
            <div className="relative flex overflow-hidden">
              <div className="animate-scroll-left flex gap-6 w-max">
                {[...JOURNEY_2, ...JOURNEY_2].map((item, i) => {
                  const Icon = item.icon;
                  return (
                    <div
                      key={i}
                      className="flex items-center gap-3 rounded-xl border border-[#48247f]/15 bg-white px-6 py-4 font-medium text-slate-700 shadow-sm transition-all duration-300 hover:border-[#702cb0]/40 hover:shadow-md whitespace-nowrap"
                    >
                      <div className="rounded-lg bg-[#f1ecfa] p-2 text-[#702cb0]">
                        <Icon size={18} />
                      </div>
                      {item.label}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="mt-12">
            <Link
              to="/contact"
              className="inline-flex min-h-[44px] items-center justify-center rounded-xl bg-gradient-to-r from-[#48247f] to-[#702cb0] px-8 py-3.5 text-xs font-semibold text-white shadow-lg transition-all duration-300 hover:-translate-y-0.5 sm:text-sm"
            >
              Start Your Journey
            </Link>
          </div>
        </section>

        {/* ===== EDUCATION BLOGS & INSIGHTS SECTION ===== */}
        <section
          id="education-blogs"
          aria-labelledby="education-blogs-heading"
          className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <motion.div
              initial={reduced ? false : { opacity: 0, y: -20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <SectionHeading
                id="education-blogs-heading"
                pill="Articles &amp; Industry Insights"
                before="Stay updated with"
                highlight="EdTech growth trends"
              />
            </motion.div>

            <div className="grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">
              {EDUCATION_BLOGS.map((blog, idx) => (
                <div
                  key={idx}
                  className="group relative flex flex-col justify-between overflow-hidden rounded-2xl border border-[#48247f]/10 bg-white p-6 shadow-[0_8px_30px_-12px_rgba(72,36,127,0.25)] transition-all duration-300 hover:-translate-y-1 hover:border-[#702cb0]/40 hover:shadow-[0_24px_48px_-12px_rgba(72,36,127,0.4)] motion-reduce:transition-none sm:p-8"
                >
                  <div className="absolute left-0 top-0 h-full w-1 origin-top scale-y-0 bg-gradient-to-b from-[#12dfbd] via-[#702cb0] to-[#48247f] transition-transform duration-500 ease-out group-hover:scale-y-100" />
                  <div>
                    <div className="mb-4 flex items-center justify-between">
                      <span className="inline-flex items-center gap-1.5 rounded-full bg-[#f1ecfa] px-3 py-1 text-xs font-semibold text-[#48247f]">
                        <BookOpen className="h-3.5 w-3.5 text-[#702cb0]" />
                        {blog.tag}
                      </span>
                      <span className="text-xs font-medium text-slate-500">{blog.readTime}</span>
                    </div>
                    <h3 className="mb-3 text-lg font-medium leading-snug tracking-tight text-[#28194f] sm:text-xl">
                      {blog.title}
                    </h3>
                    <p className="text-sm font-normal leading-relaxed text-slate-700">
                      {blog.summary}
                    </p>
                  </div>
                  <div className="mt-6 pt-4 border-t border-[#48247f]/10">
                    <span className="inline-flex items-center gap-1 text-xs font-semibold text-[#702cb0] hover:text-[#48247f] transition-colors cursor-pointer">
                      Read full article <ArrowRight className="h-3.5 w-3.5" />
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== FAQ SECTION (GEO & Answer Engine Optimization) ===== */}
        <section
          id="education-faqs"
          aria-labelledby="education-faqs-heading"
          className="relative w-full border-t border-[#48247f]/10 bg-[#f6f3fc] py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1000px] px-4 sm:px-10 lg:px-14">
            <motion.div
              initial={reduced ? false : { opacity: 0, y: -20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <SectionHeading
                id="education-faqs-heading"
                pill="Frequently Asked Questions"
                before="Got questions about our"
                highlight="Education CRM?"
              />
            </motion.div>

            <div className="space-y-4">
              {FAQS.map((faq, index) => {
                const isOpen = openFaq === index;
                return (
                  <div
                    key={index}
                    className="overflow-hidden rounded-xl border border-[#48247f]/15 bg-white shadow-sm transition-all duration-200"
                  >
                    <button
                      onClick={() => toggleFaq(index)}
                      className="flex w-full items-center justify-between p-5 text-left font-medium text-[#28194f] transition-colors hover:bg-[#fbf7ff] sm:p-6"
                      aria-expanded={isOpen}
                    >
                      <span className="flex items-center gap-3 text-base sm:text-lg">
                        <HelpCircle className="h-5 w-5 flex-shrink-0 text-[#702cb0]" />
                        {faq.q}
                      </span>
                      <ChevronDown
                        className={`h-5 w-5 flex-shrink-0 text-slate-500 transition-transform duration-300 ${
                          isOpen ? "rotate-180 text-[#702cb0]" : ""
                        }`}
                      />
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-6 pt-0 sm:px-6">
                        <p className="border-t border-[#48247f]/10 pt-4 text-sm leading-relaxed text-slate-600 sm:text-base">
                          {faq.a}
                        </p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Education;